export default {
  attendance: {
    additionalInformations: 'Additional information',
    attendanceTitle: 'Attendance',
    client: 'Customer',
    date: 'Date',
    exportAs: 'Export as',
    filePrefix: 'attendance-list.',
    noReservations: 'No reservations were found...',
    noReservationsForGivenFilters: 'No reservations were found that meet the criteria...',
    service: 'Service',
    status: 'Reservation status',
    title: 'Attendance list',
    worker: 'Employee'
  },
  attendanceListItem: {
    call: 'Call',
    cardRegistered: 'Card registered',
    category: 'Category: ',
    clientNotPresent: 'Client not present',
    clientPresentSaved: 'Changed status to present',
    clientNotPresentSaved: 'Changed status to absent',
    clientPresentReset: 'Attendance status cleared',
    formSent: 'The form was sent',
    paid: 'Paid',
    reservationDetails: 'Reservation details #{id}',
    reservationParentDetails: 'Parent reservation #{id}',
    seeMore: 'See more',
    sendEmail: 'Send e-mail',
    unPaid: 'Unpaid'
  },
  app: {
    loadingChunkAlert: {
      title: 'An error occurred during loading app',
      desc: 'The page reload is required. Unsaved changes can be lost.',
      btn: 'Reload'
    },
    pageTitle: 'Bookero - online reservations system',
    systemExpired: {
      title: 'System expired',
      desc: 'Adding a reservation will not be possible until you pay for your subscription.'
    }
  },
  autoLogin: {
    loadingText: 'Login is in progress...'
  },
  blockedTerminListItem: {
    blockedCalendarForDays: 'Block all services for days',
    blockedCalendarForHours: 'Block all services for hours',
    blockedCalendarForServiceForDays: 'Block service for days',
    blockedCalendarForServiceForHours: 'Block service for hours',
    blockedCalendarForWorker: 'Block worker',
    blockedFromSearch: 'Block from search of appointments',
    blockedFromCart: 'Block from cart',
    blockedTo: 'Blocked till',
    category: 'Category: ',
    call: 'Call',
    date: 'Blocked date',
    dateRange: 'Date',
    formSent: 'Created at:',
    reservationDetails: 'Blocked date details #{id}',
    seeBlockedTerminDetails: 'See blocked date details',
    sendEmail: 'Send e-mail'
  },
  blockedTermins: {
    date: 'Blocked date',
    blockedTo: 'Blocked to',
    noBlockedTermins: 'No blocked dates',
    noBlockedTerminsForGivenFilters: 'No blocked dates for given criteria',
    notes: 'Notes',
    onlyBlockedCalendarForDays: 'Only blockades of all services for days',
    onlyBlockedCalendarForHours: 'Obly blockades of all services for hours',
    onlyBlockedCalendarForServiceForDays: 'Only blockades of services for days',
    onlyBlockedCalendarForServiceForHours: 'Only blockades of services for hours',
    onlyBlockedCalendarForWorker: 'Only blockades of workers',
    onlyBlockedFromSearch: 'Only blockades from search of appointments',
    onlyBlockedFromCart: 'Only blockades from cart',
    service: 'Service',
    title: 'List of blocked dates',
    type: 'Blockade type',
    worker: 'Worker'
  },
  billing: {
    addNewCard: 'Add new card',
    allPricesAreNet: 'All prices quoted are net prices.',
    cardAutoPackage: 'Connected package',
    cardAutoSms: 'Connected SMS package',
    cardExpiryDate: 'Expiry date',
    cardNumber: 'Card number',
    cardRemove: 'Remove card',
    cardsTitle: 'Connected credit/debit cards',
    changeToThisPackage: 'Change to this package',
    changeYourPackage: 'Change your package',
    charge: 'Top-up',
    currentPackage: 'The current tariff:',
    currencyPerMonth: ' / mth',
    days: 'days',
    expired: 'System expired',
    expireDate: 'Expires:',
    expiresFor: 'for',
    expiresIn: 'System will expire',
    expiresSoon: 'System expires soon',
    gross: 'Gross price',
    iChoose: 'Choose',
    invoicesTitle: 'Invoice list',
    invoiceDate: 'Date of issue',
    invoiceDownload: 'Download',
    invoiceNumber: 'Invoice no',
    invoicePackage: 'Package',
    invoiceQuote: 'Quote',
    invoiceValidity: 'Validity',
    isAboutToExpire: 'Is about to expire',
    isExpired: 'Expired',
    itemCart: 'Reservation cart',
    itemCalendarIntegrations: 'Integration with Google and Outlook calendars',
    itemCommissions: 'Employee commissions',
    itemCustomers: 'Customer directory',
    itemCustomModifications: 'Individual system modules can be ordered',
    itemCustomParams: 'Expanding the form with your own parameters',
    itemDailyReservations: 'Daily reservations',
    itemHoursTable: 'Creating a schedule of opening hours',
    itemFakturownia: 'Integration with Fakturownia',
    itemMultilangugage: 'Multilanguage',
    itemPasses: 'Passes',
    itemPayments: 'Online payments<small>May connect multiple payment systems</small>',
    itemPeriodicity: 'Periodical reservations',
    itemPriceRulesAndDiscounts: 'Price rules and discounts',
    itemReservationRules: 'Reservation rules <small>(Automatic reservations)</small>',
    itemServices: 'Service management',
    itemSMS: 'SMS notifications',
    itemSystemReservation: 'Reservation system',
    itemSurveys: 'Surveys',
    itemQR: 'QR ticket generation',
    itemWhiteLabeling: 'Hidden Bookero footer in the plugins',
    itemWorkers: 'Worker management',
    itemWorkersOneWorker: '(one employee as administrator account)',
    itemWorkersUpTo: '(to {maxWorkers} employees)',
    itemWorkesNoLimit: '(no limit)',
    itemWWW: 'Website creator',
    lackOfCompanyData: 'No company details are provided - the invoice will be issued to an individual.',
    loadingCardsData: 'Loading card data',
    loadingCardsDataError: 'An error ocurred during loading card data.',
    month1: '1 month',
    month6: '6 months',
    month12: '12 months',
    noCardsToDisplay: 'No connected cards',
    noInvoiceDataTitle: 'No invoice details',
    noInvoiceDataCardDesc: 'Please fill in the company data before adding debit/credit card',
    noInvoiceDataDesc: 'Please fill in the company data before placing an order',
    noInvoiceDataBtn: 'Go to settings',
    renewThisPackage: 'Renew your package',
    renewThisPackageFor1Month: 'Renew your package for 1 month',
    renewThisPackageFor6Months: 'Renew your package for 6 months',
    renewThisPackageFor12Months: 'Renew your package for 12 months',
    sms: 'SMS',
    smsLimit: 'SMS limit:',
    smsPrice: 'pn / SMS',
    smsTitle: 'SMS messages',
    title: 'Settlements',
    youCanIncreaseSMSLimit: 'You can increase your SMS limit by selecting one of the packages on the right.',
    yourCurrentPackage: 'Your current package',
    yourPlan: 'Your plan',
    youSave: 'You save'
  },
  billingInvoiceItem: {
    date: 'Date of issue:',
    downloadInvoice: 'Download invoice',
    invoiceNumber: 'Invoice number:',
    invoicePrefix: 'invoice-',
    package: 'Package:',
    sms: 'SMS',
    smsPackage: 'SMS top-ups',
    quote: 'Quote:',
    validity: 'Validity:'
  },
  billingPopup: {
    addCreditCard: 'Connect credit/debit card to automatically renew packages',
    basicPackageEnabled: 'The basic package is enabled',
    changePackage: 'Change package',
    expandPackage: 'Extension of the package',
    iamBuying: 'I order with payment obligation',
    months: ' months',
    oneMonth: '1 month',
    packageDuration: 'Duration:',
    paymentError: 'An error occurred during card payment. Please try again.',
    paymentMethod: 'Payment method:',
    paymentSuccess: 'Card payment successfully finished.',
    payWithCard: 'Pay with card {cardNumber}',
    payWithGateway: 'Pay via payment gateway',
    priceWithTax: 'Price with VAT:',
    processingCardPayment: 'Processing card payment...',
    redirectSoon: 'In a moment, we\'ll redirect you to the payment page...',
    selectedPackage: 'Selected package:',
    selectedPaymentMethod: {
      gateway: 'PayPal payment gateway',
      card: 'card {cardNumber}'
    },
    selectPaymentMethod: 'Select payment method:',
    smsPackage: 'SMS top-up',
    systemExpiresIn: 'The system expires in {leftDays} days'
  },
  blockDatePopup: {
    blockDate: 'Block date',
    blockingDate: 'Blocking...',
    dateBlocked: 'The date has been blocked',
    email: 'E-mail address (optional):',
    errorDesc: 'An error occurred during creating a date block.',
    errorTitle: 'An error occurred',
    howLong: 'For how long block the date (in minutes):',
    name: 'Name (optional):',
    phone: 'Phone number (optional):',
    title: 'Block date'
  },
  calendar: {
    addBlockade: 'Block calendar',
    day1: {
      short: 'Mo',
      long: 'Monday',
      shortPart1: 'Mon',
      shortPart2: 'day'
    },
    day2: {
      short: 'Tu',
      long: 'Tuesday',
      shortPart1: 'Tue',
      shortPart2: 'sday'
    },
    day3: {
      short: 'Wd',
      long: 'Wednesday',
      shortPart1: 'Wed',
      shortPart2: 'nesday'
    },
    day4: {
      short: 'Th',
      long: 'Thursday',
      shortPart1: 'Thu',
      shortPart2: 'rsday'
    },
    day5: {
      short: 'Fr',
      long: 'Friday',
      shortPart1: 'Fri',
      shortPart2: 'day'
    },
    day6: {
      short: 'Sa',
      long: 'Saturday',
      shortPart1: 'Sat',
      shortPart2: 'urday'
    },
    day7: {
      short: 'Su',
      long: 'Sunday',
      shortPart1: 'Sun',
      shortPart2: 'day'
    },
    forDays: {
      collapseAll: 'Hide all',
      expandAll: 'Expand all',
      servicesLabel: 'Service name'
    },
    month1: {
      short: 'Jan',
      long: 'January',
      genitive: 'January'
    },
    month2: {
      short: 'Feb',
      long: 'February',
      genitive: 'February'
    },
    month3: {
      short: 'Mar',
      long: 'March',
      genitive: 'March'
    },
    month4: {
      short: 'Apr',
      long: 'April',
      genitive: 'April'
    },
    month5: {
      short: 'May',
      long: 'May',
      genitive: 'May'
    },
    month6: {
      short: 'Jun',
      long: 'June',
      genitive: 'June'
    },
    month7: {
      short: 'Jul',
      long: 'July',
      genitive: 'July'
    },
    month8: {
      short: 'Aug',
      long: 'August',
      genitive: 'August'
    },
    month9: {
      short: 'Sep',
      long: 'September',
      genitive: 'September'
    },
    month10: {
      short: 'Oct',
      long: 'October',
      genitive: 'October'
    },
    month11: {
      short: 'Nov',
      long: 'November',
      genitive: 'November'
    },
    month12: {
      short: 'Dec',
      long: 'December',
      genitive: 'December'
    },
    other: {
      at_hour: 'at the hour',
      expandAllReservations: 'Expand all reservations',
      export_as: 'Export as',
      noReservationsForThisService: 'No reservations',
      ongoingBlockadesOnHour: 'Blockades lasting at the hour {hour}',
      ongoingReservationsOnHour: 'Reservations lasting at the hour {hour}',
      ongoingReservationsAndBlockadesOnHour: 'Reservations and blockades lasting at the hour {hour}',
      reservations: 'Reservations',
      showOnlyReservations: 'hide free termins',
      show_today: 'Show today',
      upcomingReservations: 'Upcoming reservations',
      youCannotDisableThisOptionWhenFiltersAreActive: 'When filtering is enabled, this option cannot be disabled',
      youWantToAddReservation: 'You\'re going to add a reservation of a day {date} per hour {time}'
    }
  },
  calendarBlockadePopup: {
    blockadeAdded: 'Blockade added',
    blockadeAddErrorDesc: 'An error occurred during adding blockade. Please try again.',
    blockadeAddErrorTitle: 'An error occurred',
    blockadeEdited: 'Blockade edited',
    blockingType: 'Blockade type',
    blockingTypeCalendar: 'Calendar blockade',
    blockingTypeService: 'Service blockade',
    blockingTypeWorker: 'Worker blockade',
    description: 'Blockade description',
    endDate: 'End of blockade',
    selectBlockingType: 'Select type of blockade',
    selectService: 'Select a service',
    selectWorker: 'Select a worker',
    startDate: 'Start of blockade',
    title: 'Add blockade',
    titleEdit: 'Edit blockade'
  },
  calendarDayPopupReservation: {
    cancelReservation: 'Cancel the reservation',
    cancelingReservationTitle: 'Cancellation of reservation',
    cancelingReservationDesc: 'The selected reservation is periodical. Cancel only this reservation, or cancel it together with all future cycle bookings?',
    cancelingReservationCancelBtn: 'Cancel all',
    cancelingReservationOkBtn: 'Cancel only this reservation',
    cancelingReservation2Title: 'Cancellation of reservation',
    cancelingReservation2Desc: 'Do you want to cancel this reservation?',
    cancelingReservation2Btn: 'Cancel the reservation',
    cardRegistered: 'Registered card',
    clientNotPresent: 'The client didn\'t show up',
    clientNotPresentTitle: 'The client didn\'t come?',
    clientNotPresentDesc: 'If the client has not shown up, click Yes to write it down in his statistics.',
    clientNotPresentBtn: 'Yes, the client didn\'t show up',
    clientNotPresentSaved: 'The absence of the client was recorded',
    category: 'Category: ',
    contactWithClient: 'Contact the customer',
    dateUnblocked: 'Selected date has been unblocked',
    email: 'email:',
    getMoreInfoAboutReservation: 'Find out more about the reservation',
    getMoreInfoAboutBlockedDate: 'Find out more about the blocked date',
    paid: 'Paid',
    phone: 'tel:',
    reservationCancelled: 'The reservation was cancelled',
    reservationCancelledNotificationsSent: 'The reservation was cancelled, notifications were sent',
    unblockDate: 'Unblock date',
    unblockDateTitle: 'Unblock date',
    unblockDateDesc: 'The selected blocked date is periodical. Unlock only this date, or unblock it together with all future blocked dates?',
    unblockDateCancelBtn: 'Unblock all',
    unblockDateOkBtn: 'Unblock only this one',
    unblockDate2Title: 'Unblock date',
    unblockDate2Desc: 'Do you want to unblock this date?',
    unblockDate2Btn: 'Unblock date',
    unpaid: 'Unpaid',
    waitingListTitle: 'You have a waiting list for the selected date',
    waitingListDesc: 'Should notify the following people of the free time?<br>',
    waitingListBtn: 'Yes, notify!'
  },
  calendarExportPopup: {
    anyPaymentStatus: 'Any payment status',
    dateSince: 'Date from',
    dateTo: 'Date to:',
    downloadFile: 'Download file',
    downloadingFile: 'Download...',
    showContactData: 'Show contact details:',
    title: 'Export reservation'
  },
  calendarPeriodicities: {
    acceptedInquiries: 'Confirmed:',
    activeCycles: 'Active cycles only',
    allCycles: 'All cycles',
    autoRenew: 'Cycle renewed automatically',
    canceledInquiries: 'Cancelled:',
    cycle: 'Cycle',
    cycleCreationDate: 'Use the cycle creation date',
    cycleEnd: 'Cycle end:',
    cycleReservations: 'Reservations in the cycle',
    cycleStart: 'Cycle start:',
    cycleStartDate: 'Use the cycle start date',
    firstReservation: 'First:',
    lastReservation: 'Last:',
    loadMore: 'Show more reservations from the cycle',
    loadingError: 'The reservations from this cycle could not be loaded.',
    loadingReservations: 'Loading reservations from the cycle...',
    nearestReservation: 'Nearest:',
    noCycles: 'No recurring reservations were found...',
    noCyclesForGivenFilters: 'No recurring reservations were found that meet the criteria...',
    noNearestReservation: 'No future reservations',
    noReservationsInCycle: 'No reservations in this cycle...',
    paymentForWholeCycle: 'Payment for the whole cycle',
    rejectedInquiries: 'Rejected:',
    showReservations: 'Show reservations from the cycle',
    summary: 'Summary',
    totalInquiries: 'All reservations:'
  },
  calendarPeriodicityPopup: {
    dateFrom: 'Date from',
    dateTo: 'Date to',
    onlyFuture: 'Future only',
    searchByReservationID: 'Reservation number...',
    title: 'Reservations from cycle #{id}'
  },
  calendarWorkers: {
    checkTimetable: 'Check the schedule',
    clickToHideWorkers: 'Click to hide workers',
    exportAs: 'Export as ',
    hideWorkersWithoutReservation: 'Hide employees without reservation',
    isClosedWarning: '<strong>Warning!</strong> That day is closed.',
    someWorkersAreHidden: 'Hiding workers is enabled ({number})',
    title: 'Occupancy rates',
    workerIsFree: 'The employee has a vacancy',
    workerNotSupportThisService: 'doesn\'t perform this service',
    workerNotSupportThisServiceCategory: 'doesn\'t perform this category of services',
    workerNotWorkInThisHours: 'The employee does not work during these hours'
  },
  calendarWorkersFiltersPopup: {
    hideWorkersWithoutReservation: 'Hide workers without a reservation',
    noWorkersForGivenPhrase: 'No workers match the given phrase',
    searchWorkersByName: 'Enter the worker\'s name',
    selectedWorkers: 'Selected workers: {count}',
    title: 'Configuration of hiding workers'
  },
  calendarView: {
    periodicities: 'Recurring reservations',
    reservationsCalendar: 'Reservation calendar',
    reservationsForDays: 'Daily reservations',
    title: 'Reservation calendar',
    workersCalendar: 'Occupancy rates'
  },
  changeDatePopup: {
    changeTerm: 'Change the date',
    changeReservationDate: 'Change reservation date - select a date',
    clientNotificationTitle: 'Notification to the customer',
    clientNotificationDesc: 'Do you want to notify the customer by e-mail about changes?',
    clientNotificationBtnCancel: 'Don\'t notify',
    clientNotificationBtnOk: 'Yes, notify',
    copyReservation: 'Copy the reservation',
    copyReservationTitle: 'Copy this reservation - select a term',
    loadingTerms: 'Loading data...',
    reservationSucessfullyCopied: 'The reservation was successfully copied',
    reservationTermChanged: 'The reservation date has been changed',
    select: 'Choose'
  },
  common: {
    block: {
      loadingData: 'Loading data...',
      savingData: 'Saving...'
    },
    invoiceDownloader: {
      generateInvoice: 'Issue an invoice',
      generatingInvoice: 'An invoice is being issued...',
      downloadInvoice: 'Invoice #{invoiceNumber}',
      downloadingInvoice: 'Downloading invoice...',
      generateReceipt: 'Issue a receipt',
      generatingReceipt: 'A receipt is being issued...',
      downloadReceipt: 'Receipt #{receiptNumber}',
      downloadingReceipt: 'Downloading receipt...',
      filenameInvoice: 'invoice-{invoiceNumber}.pdf',
      filenameReceipt: 'receipt-{receiptNumber}.pdf',
      successMessageInvoice: 'The invoice #{externalInvoiceNumber} has been generated.',
      successMessageReceipt: 'The receipt #{externalReceiptNumber} has been generated.',
      errorMessageTitleInvoice: 'The invoice generation has failed',
      errorMessageTitleReceipt: 'The receipt generation has failed',
      errorMessageDesc: 'Try again or check the integration settings with the Fakturownia API.'
    },
    mailSmsLegendText: {
      desc1: 'Inserts available for use in the content:',
      desc2: 'Inserts a reservation ID preceded by a "#"',
      desc3: 'Inserts a cart reservations ID preceded by a "#"',
      desc4: 'Inserts date of reservation',
      desc5: 'Inserts time of reservation',
      desc6: 'Inserts the selected service',
      desc7: 'Inserts the category name of the selected service',
      desc8: 'Inserts name of the worker connected with the selected service',
      desc9: 'Inserts email of the worker connected with the selected service',
      desc10: 'Inserts the URL to the Google Meet',
      desc11: 'Inserts the name of the employee performing the service'
    },
    pagination: {
      infoCounts: 'Display: records {from}-{to} of {total} found.',
      infoCountsEmpty: 'Display: no records to display',
      activeFilters: 'Filtering is active.',
      page: 'Page',
      from: 'from {max}'
    },
    toggleAll: {
      label: 'Check / uncheck all'
    },
    ui: {
      add: 'Add',
      addReservation: 'Add reservation',
      addingReservation: 'Adding of the reservation',
      advance: 'Advance',
      allBlockedTerminTypes: 'Show all blocked termins',
      allReservationTypes: 'Show all reservations',
      allServices: 'All services',
      allWorkers: 'All employees',
      and: ' and ',
      back: 'Go back',
      blockedDatesNumber: 'Number of blocked dates',
      cancel: 'Cancel',
      childrenNumber: 'Children number',
      clearFilters: 'Clear filters',
      clientInfo: 'Customer information',
      close: 'Close',
      closeNotNotify: 'Close, not notify',
      closed: 'Closed',
      closedNoCap: 'closed',
      copied: 'Copied',
      copy: 'Copy',
      copyToClipboard: 'Copy to clipboard',
      cost: 'Cost: ',
      creationDate: 'Use reservation creation date',
      currentLanguage: 'en',
      cycle: 'Cycle:',
      dailyBlockedTermins: 'Show only daily blocked termins',
      dailyReservations: 'Show only daily reservations',
      datepickerFormat: 'MMM d, yyyy',
      datepickerFormatShort: 'MMM d',
      datepickerLanguage: 'en',
      day: 'day',
      days: 'days',
      daysNumber: 'Days number',
      nigthsNumber: 'Nights number',
      delete: 'Delete',
      edit: 'Edit',
      elementNotExists: 'Selected element not exists',
      emailPrefix: 'email:',
      firstVisit: 'First visit',
      for: 'for',
      from: ' from ',
      free: 'Free',
      freeNoCap: 'free',
      freeOrServiceUnavailable: 'free or unavailable service',
      freeWork: 'Free from work',
      fullCycleCost: 'Cycle cost: ',
      hide: 'Hide',
      hideDetails: 'Hide details',
      hideViewOptions: 'Hide view options',
      hourlyBlockedTermins: 'Show only hourly blocked termins',
      hourlyReservations: 'Show only hourly reservations',
      hoursShortcut: 'h',
      incomeCurrency: ' GBP',
      invalidFields: 'Some fields are filled in incorrectly',
      invoiceRequest: 'Invoice requested',
      invoiceRequestCompany: 'Invoice requested',
      loading: 'Loading...',
      loadingData: 'Loading in progress...',
      loadingError: 'An error ocurred during data loading',
      loadMoreResults: 'Load more results',
      noResults: 'No matching results...',
      minutesShortcut: 'min',
      no: 'No',
      none: 'None',
      noPayment: 'No payment',
      noReservations: 'No reservations...',
      noPasses: 'No passes...',
      noReservationsForGivenFilters: 'No reservation meeting the criteria...',
      ok: 'OK',
      ongoing: 'ongoing',
      paymentDate: 'Use payment date',
      paymentStatus: 'Payment status',
      paid: 'Paid',
      paidWithCash: 'Paid with cash',
      pass: 'Pass',
      peopleNumber: 'People number',
      phonePrefix: 'phone:',
      phoneNumberPrefix: '44',
      publish: 'Publish',
      reservation: {
        term: 'Reservation date',
        date: 'Reservation date',
        dateAs: 'Reservation date as',
        dateRange: 'Reservation',
        preferredPeopleCount: 'Preferred number of people',
        selectTermRequired: 'You must choose the date of booking'
      },
      reservationDate: 'Use reservation date',
      reservationsNumber: 'Number of reservations',
      save: 'Save',
      saveAllChanges: 'Save all changes',
      saveChanges: 'Save changes',
      search: 'Search...',
      seeReservationDetails: 'See reservation details',
      selectService: 'Select service',
      service: 'Service:',
      services: {
        servicesWithoutCategory: 'Services without categories'
      },
      show: 'Show',
      showViewOptions: 'Show view options',
      thisFieldIsRequired: 'This field is required',
      to: 'to ',
      today: 'Today',
      transactionID: 'Transaction ID',
      unpaid: 'Unpaid',
      worker: 'Employee:',
      variations: {
        blockedDate: {
          single: 'blocked date',
          plural1: 'blocked dates',
          plural2: 'blocked dates'
        },
        person: {
          single: 'person',
          plural1: 'people',
          plural2: 'people'
        },
        reservation: {
          single: 'reservation',
          plural1: 'reservations',
          plural2: 'reservations'
        },
        currentBlockedDate: {
          single: 'ongoing blocked date',
          plural1: 'ongoing blocked dates',
          plural2: 'ongoing blocked dates'
        },
        currentReservation: {
          single: 'ongoing reservation',
          plural1: 'ongoing reservations',
          plural2: 'ongoing reservations'
        },
        pastReservation: {
          single: 'took place',
          plural1: 'took place',
          plural2: 'took place'
        }
      },
      yes: 'Yes',
      yesRemove: 'Yes, remove'
    },
    workHours: {
      workingHours: 'Working hours:'
    }
  },
  companyForm: {
    address: 'Address:',
    applyVatID: 'Apply',
    city: 'City:',
    companyCountry: 'Country:',
    companyData: 'Company data',
    companyDataSaved: 'Company data saved',
    companyName: 'Company name:',
    email: 'E-mail:',
    emailIsInvalid: 'This e-mail is invalid',
    emailIsTaken: 'This e-mail is taken. Please use another one.',
    fillThisFieldToChangePassword: 'Fill in this field if you want to change your password',
    invalidFileFormat: 'Not allowed file format.',
    invalidVATID: 'Invalid VAT ID',
    invalidVATIDDesc: 'VAT ID must contains 10 numbers without spaces and dashes.',
    invalidVATID2Desc: 'We cannot found data for the provided VAT ID. Please check the provided VAT ID and try again.',
    iWantInvoice: 'I need the VAT invoice:',
    language: 'App language',
    logo: 'Logo:',
    logoTitle: 'Logo',
    name: 'First and last name:',
    nipRule: 'VAT ID must contains 10 numbers without spaces and dashes',
    openingHours: 'Working hours',
    password: 'Password:',
    passwordConfirmation: 'Confirm password:',
    phone: 'Phone:',
    postalCode: 'Postcode:',
    receiveNotifications: 'Receive notifications about reservations:',
    receiveNotificationsDesc: 'If this option is enabled, notifications about reservations will be sent to the above e-mail.',
    removeLogo: 'Remove logo',
    selectCountry: '-- Select country --',
    selectRegion: '-- Select region --',
    submitNewFileToChangeLogo: 'Send a new file to change your logo',
    supportedFormats: 'Supported file formats: JPG, PNG.',
    taxID: 'Tax ID:',
    thisEmailWillBeUsedToGetNotificationsAboutNewReservations: 'This e-mail address will be used to receive notifications of new reservations',
    thisEmailWillBeUsedToLogin: 'This e-mail address will be used to log in to the panel',
    timezone: 'Timezone',
    timezoneAndLanguage: 'Timezone and language',
    userData: 'User data',
    vatIDCheckInProgress: 'Veryfing...',
    www: 'Website:',
    wwwDescription: 'This is the address of the page to which the client is redirected after cancelling the reservation.<br>This address should start with "http://" or "https://".'
  },
  cookieBanner: {
    text: 'Our website uses cookies. By using the service you agree to save or use them.'
  },
  creditCardItem: {
    cardHasBeenRemoved: 'Card removed successfully',
    cardHasNotBeenRemovedProperly: 'Card not removed - please try again',
    confirmCardRemoveDesc: 'After removing the cart, the automatical renewal of the related services won\'t work if it is the only card connected with these services.',
    confirmCardRemoveTitle: 'Do you want to remove the selected card?',
    noAutoPackage: 'None',
    noAutoSmsPackage: 'None',
    removeCard: 'Remove card'
  },
  creditCardPopup: {
    addCard: 'Add card',
    autoPackage: 'Renew automatically package',
    autoSMS: 'Renew automatically SMS package',
    autoSMSNumber: 'SMS number bought on renew',
    cardCvc: 'CVC code:',
    cardExpiryDate: 'Card expiry date:',
    cardHasBeenAdded: 'Card added successfully',
    cardHasNotBeenAdded: 'Card has not been added',
    cardNumber: 'Card number:',
    disclaimer: 'Data of your card will be processed by Stripe payment system. Bookero won\'t store your card data.',
    errors: {
      cardDate: 'Enter valid date',
      cardNumber: 'Enter valid card number',
      cvc: 'Enter CVC code',
      package: 'Select package',
      smsNumber: 'Select SMS package'
    },
    packageChangeInfo: 'Warning! During nearest renewal your account will be changed from the {currentPackage} package to {selectedPackage} package.',
    selectAutoPackage: 'Select package',
    selectPackage: 'Select package',
    selectSmsNumber: 'Select SMS package',
    title: 'Add new card'
  },
  customerAutocomplete: {
    email: 'E-mail:',
    name: 'First and last name',
    noResults: 'No results...',
    phone: 'Phone:'
  },
  customerFormPopup: {
    addClient: 'Add customer',
    email: 'E-mail:',
    emailIsInUse: 'The e-mail address you provide is already used by another customer',
    emailIsRequired: 'E-mail address is required',
    invalidEmail: 'Invalid e-mail address',
    mobilePhone: 'A cell phone:',
    mobilePhoneIsInvalid: 'The phone number is invalid',
    mobilePhoneIsInUse: 'The phone number given is already used by another customer',
    mobilePhoneIsRequired: 'Valid phone number is required',
    name: 'First and last name:',
    nameIsRequired: 'First and last name is required',
    titleAdd: 'Adding a customer',
    titleEdit: 'Edit customer'
  },
  customerNote: {
    remove: 'Delete the note',
    removed: 'The selected note has been deleted'
  },
  customerNotePopup: {
    addNote: 'Add note',
    content: 'Note text:',
    contentIsRequired: 'Note text is required',
    notificationField: 'Param used in notifications',
    titleAdd: 'Adding a customer note',
    titleEdit: 'Editing a customer note'
  },
  customerPopup: {
    accepted: 'Accepted',
    acceptedTosAndPrivacyPolicy: 'Accepted Terms of Service and privacy policy:',
    addNewNote: 'Add new note',
    agreementForEmail: 'Consent to marketing activities via e-mail:',
    agreementForPhone: 'Consent for marketing activities via telephone calls:',
    contactData: 'Contact details:',
    customerAgreements: 'Consents given',
    customerStats: 'Customer statistics:',
    filterReservations: 'Filter reservations',
    goToDate: 'Go to date',
    lastChanged: 'last revision:',
    no: 'No',
    noData: 'No data',
    noNotes: 'No notes...',
    notesAboutClient: 'Customer notes:',
    removeClient: 'Remove the customer',
    removingCustomerTitle: 'Removal of the customer',
    removingCustomerDesc: 'Are you sure you want to remove the selected customer?',
    removingCustomerBtn: 'Remove the customer',
    reservations: 'Reservations',
    passesHistory: 'Customer pass history',
    reservationsHistory: 'Customer reservation history:',
    reservationsInTheLastMonth: 'Reservations in the last month:',
    selectedClientRemoved: 'The selected customer has been deleted',
    totalIncome: 'All revenue:',
    totalPercent: 'Percentage of total:',
    unableToLoadCustomer: 'Error during data load',
    unableToLoadCustomerDesc: 'Unable to load customers data.',
    yes: 'Yes'
  },
  customerReservation: {
    accepted: 'Accepted',
    cardRegistered: 'Card registered',
    cancelled: 'Cancelled',
    clientNotPresent: 'Customer not present',
    clientPresent: 'Customer present',
    hour: 'Hour:',
    no: 'NO',
    paid: 'Paid',
    presence: 'Presence:',
    price: 'Price:',
    rejected: 'Rejected',
    status: 'Status:',
    unpaid: 'Unpaid',
    yes: 'YES',
    waitingList: 'Waiting list',
    waitsForAccept: 'Awaiting acceptance',
    waitsForPayment: 'Awaiting payment'
  },
  customers: {
    addClient: 'Add customer',
    email: 'E-mail',
    exportAs: 'Export as ',
    income: 'Income',
    name: 'First and last name',
    noClientsFound: 'No customers were found...',
    phone: 'Phone',
    searchInClients: 'Search among customers...',
    title: 'Customers',
    youHaveABaseOfClients: 'You have a customer base of {totalCustomers}'
  },
  customersListItem: {
    email: 'E-mail:',
    emailTooltip: 'email:',
    income: 'Income:',
    informations: 'Information',
    name: 'First and last name:',
    noData: 'No data',
    phone: 'Phone:',
    phoneTooltip: 'tel:',
    removeAllReservationsWithCustomer: 'Remove all customer reservations with customer ({count})',
    removeClient: 'Remove customer',
    removingClientTitle: 'Removal of the customer',
    removingClientDesc: 'Are you sure you want to remove the selected customer?',
    removingClientBtn: 'Delete a customer',
    selectedClientRemoved: 'The selected customer has been deleted'
  },
  dashboard: {
    buySmsPackage: 'Buy an SMS package',
    buySubscription: 'Subscription purchase',
    clickToEnableReservations: 'Click to change settings',
    clickToRenew: 'Click to renew the package',
    confirmEmailAddress: 'Confirm your e-mail address to get full functionality of Bookero.',
    confirmEmailAddressWorker: 'Confirm your e-mail address.',
    confirmationSend: 'Confirmation e-mail has been sent. Please check your e-mail inbox.',
    connectGoogleCalendar: 'Connect your account to the Google Calendar',
    connectOutlookCalendar: 'Connect your account to the Outlook calendar',
    day: 'day',
    days: 'days',
    daysReservations: 'Daily reservations',
    dayPlan: 'Day plan',
    googleCalendarActiveNoConnectedCalendar: 'Integration with Google Calendar is enabled, but no calendar-related account is specified.',
    loadingWaitingRequests: 'Pending reservations are being loaded...',
    noWaitingRequests: 'You currently do not have any pending reservations',
    outlookCalendarActiveNoConnectedCalendar: 'Integration with Outlook Calendar is enabled, but there is no account associated with calendars.',
    paymentsEnabledNoPaymentMethod: 'Payments are enabled, but no payment method is defined.',
    pluginReservationsDisabled: 'Attention! Adding reservations through the plugin is disabled.',
    resendConfirmation: 'Resend verification e-mail',
    resendSending: 'Sending...',
    servicesEnabledNoActiveService: 'You do not have any active service, despite the service feature being enabled.',
    servicesWithoutWorkers: 'You have services without assigned employees.',
    smsActiveNoSmsToSend: 'SMS notifications are active but your SMS pool has been exhausted.',
    showAll: 'Show all',
    showLess: 'Show less',
    todaysReservations: 'Reservations for today',
    toUseBookero: 'to use all Bookero functions.',
    yourAccountExpired: 'Your account has expired.',
    yourPackageExpiresIn: 'Your package expires for',
    yourPanel: 'Your reservation management panel',
    upcomingWeekReservations: 'Reservations for the next week',
    updateData: 'Refresh',
    updatingData: 'Refreshing...',
    updateRequired: 'There are changes in reservations - click "Refresh" to load updated data:',
    warning: 'Attention!',
    waitingRequests: 'Pending inquiries',
    waitsForAccept: 'waits for accept',
    workersWithoutServices: 'You have employees without assigned services.'
  },
  dashboardReservations: {
    daysReservationsStarts: 'Reservations starting today',
    daysReservationsEnds: 'Reservations ending today',
    loadingReservations: 'Loading data...',
    noEndingReservations: 'No reservations ending today...',
    noEndingReservationsForGivenFilters: 'No reservations ending today meeting the criteria...',
    noStartingReservations: 'No reservations starting today...',
    noStartingReservationsForGivenFilters: 'No reservations starting today meeting the criteria...',
    noUpcomingReservations: 'No upcoming reservations...',
    noUpcomingReservationsForDays: 'No upcoming reservations today...',
    noUpcoimngReservationsForGivenFilters: 'No upcoming reservations meeting the criteria...',
    reservationsForUpcomingWeek: 'Reservations for the next week',
    searchClients: 'Search for customers...',
    selectDay: 'Select day',
    show: '(show)',
    showOnlyUpcomingReservations: 'Show only future reservations',
    todaysReservations: 'Reservations for today',
    tookPlace: 'Today {tookPlace} already {count} {reservationWord}'
  },
  dashboardTodayTimeline: {
    allWorkersAreFreeToday: 'All the employees are off today...',
    checkTimetables: 'Check the schedule',
    now: 'Now',
    workerIsFree: 'The employee has a vacancy',
    workerNotWorksInThisHours: 'The employee does not work during these hours'
  },
  day: {
    from: 'From:',
    to: 'To:'
  },
  discounts: {
    addNew: 'Add a new discount',
    couponsCount: 'Number of codes',
    couponsUsageCount: 'Number of code usage',
    emptyState: 'No defined discounts...',
    loadingState: 'Data loading in progress...',
    name: 'Name of the discount',
    params: 'Parameters',
    title: 'Discount codes'
  },
  discountCodeFormPopup: {
    codesCount: 'Number of codes to be generated',
    generateCodes: 'Generate discount codes',
    provideCodesCount: 'Enter the number of codes',
    title: 'Generating discount codes'
  },
  discountCodeListItem: {
    discountCode: 'Discount code',
    removeDiscountCode: 'Delete the discount code',
    selectedCodeHasBeenRemoved: 'The selected discount code has been deleted',
    usedCount: 'Number of uses'
  },
  discountsListItem: {
    countOfCodes: 'Number of codes',
    countOfUsageCodes: 'Number of code usage',
    dayOfReservation: 'The day for which the reservation is made',
    dayOfReservationSent: 'Date of reservation',
    dependsFromDate: 'Depending on the date of reservation',
    discount: 'Discount',
    discountName: 'Name of the discount',
    editDiscount: 'Edit the discount',
    limitOfUse: 'Limit on code usage',
    params: 'Parameters',
    removeDiscount: 'Remove the discount',
    removeDiscountTitle: 'Discount removal',
    removeDiscountDesc: 'Are you sure you want to remove the selected discount?',
    removeDiscountBtn: 'Delete discount',
    reservationHour: 'Depends from reservation hours:',
    selectedDiscountRemoved: 'The selected discount has been removed',
    services: 'Services'
  },
  discountsForm: {
    addTitle: 'Adding a discount',
    atLeastOneServiceIsRequired: 'At least one service is required',
    codeExample: 'e.g. DISCOUNT_%C_%N',
    codeLimits: 'Limit on code usage',
    codeMask: 'Code mask',
    codeMaskDescription: '%C - random character [A-Z], %N - random number [0-9], example code',
    dateRange: 'Range of dates',
    dependsFromHour: 'Depending on the time of reservation:',
    dependsFromReservationDate: 'Depends on the date of reservation',
    discountAdded: 'The discount has been added',
    discountCode: 'Discount code',
    discountCodes: 'Discount codes',
    discountConfigurationChanged: 'The discount configuration has been changed',
    discountInPercents: 'Discount in %',
    discountInQuote: 'Discount quote:',
    discountParams: 'Discount parameters',
    discountTooLow: 'Percentage discount must be higher than zero',
    discountQuoteTooLow: 'Quote discount must be higher than zero',
    discountTooHight: 'Percentage discount cannot be higher than 100%',
    discountType: 'Discount type:',
    discountTypePercent: 'Percentage',
    discountTypeQuote: 'Quote',
    editTitle: 'Editing discount',
    emptyState: 'No discount codes',
    generateNewCodes: 'Generate discount codes',
    hoursRange: 'Range of hours:',
    limitedCode: 'Limit code',
    limitTooLow: 'Limit must be higher than zero',
    name: 'Name of the discount',
    numberOfUses: 'Number of uses',
    reservationDay: 'The day for which the reservation is made',
    reservationDaySubmit: 'Date of reservation',
    servicesTitle: 'Services',
    toGenerateDiscountCodesSaveADiscount: 'To generate discount codes using the new code mask, you must first save the discount.',
    youCanGenerateNewCodesAfterSavingADiscount: 'Generating discount codes will be available after saving the discount.'
  },
  emailPreview: {
    accepted: 'Accepted',
    cancelled: 'Cancelled',
    cartStatusUpdated: 'The status of the reservation cart has been updated',
    exampleService: 'Sample service to choose from',
    paid: 'Paid',
    reserveTermsList: 'List of reserved terms',
    waitingList: 'Assigned to the waiting list',
    worker: 'Employee',
    workerExample: 'Example Employee'
  },
  errors: {
    allWorkersAndServicesWithIntegrationEnabled: {
      title: 'Missing calendar associations',
      desc: 'To save settings, all workers and services with integration enabled must have an associated calendar selected.'
    },
    loadError: {
      title: 'Error while downloading data',
      desc: 'An error occurred during the loading of the data. Refresh the page to try again.',
      refresh: 'Refresh page'
    },
    operationError: {
      backToDashboard: 'Go back to dashboard',
      desc: 'The selected operation has failed. Do you want to try again?',
      descNoPermissions: 'Operation has failed due lack of permissions.',
      ok: 'OK',
      repeat: 'Repeat the operation',
      title: 'The operation has failed',
      titleNoPermissions: 'No permissions'
    },
    operationErrorWithoutCallback: {
      title: 'Server communication error occurred',
      desc: 'Please verify on the list if the data has been saved properly. If not - please add data again.'
    }
  },
  help: {
    emailLabel: 'over the email',
    emailAddress: 'partner@bookero.pl',
    heading: 'If you need help with the configuration of your account or have problems with the system, we are at your disposal',
    newsLabel: 'news you can find on:',
    phoneLabel: 'over the phone',
    phoneNumber: '+48 790 328 686',
    selectTopicToDisplay: 'Select topic to display',
    title: 'Help',
    toc: 'Table of Contents'
  },
  history: {
    additionalInformations: 'Additional information',
    client: 'Customer',
    date: 'Date',
    exportAs: 'Export as',
    filePrefix: 'reservation-history.',
    noReservations: 'No reservations were found...',
    noReservationsForGivenFilters: 'No reservations were found that meet the criteria...',
    service: 'Service',
    status: 'Reservation status',
    statusCancelled: 'Cancelled',
    statusClientNotPresent: 'Customer absent',
    statusConfirmed: 'Confirmed',
    statusNew: 'New inquiry',
    statusRejected: 'Rejected',
    statusTitle: 'Status',
    statusWaitingList: 'Waiting list',
    title: 'Reservation history',
    worker: 'Employee'
  },
  historyListItem: {
    call: 'Call',
    cancelled: 'Cancelled',
    cardRegistered: 'Card registered',
    cartID: 'Cart ID:',
    passCode: 'Used pass code:',
    category: 'Category: ',
    clientNotPresent: 'Customer not present',
    confirmed: 'Confirmed',
    editReservation: 'Edit the reservation',
    formSent: 'The form was sent',
    newRequest: 'New request',
    paid: 'Paid',
    rejected: 'Rejected',
    reservationDetails: 'Reservation details #{id}',
    reservationParentDetails: 'Parent reservation #{id}',
    restoreReservation: 'Restore the reservation',
    seeMore: 'See more',
    sendEmail: 'Send e-mail',
    unPaid: 'Unpaid',
    waitingList: 'Waiting list'
  },
  login: {
    allFieldsAreRequired: 'All fields are required to log in.',
    anErrorOccurredPleaseCheckInternetConnection: 'There was an error while logging in. Check your Internet connection and try again.',
    anErrorOccurredUseFormBelow: 'There was an error while logging in. Log in using the form',
    email: 'E-mail address',
    invalidData: 'Your login details are incorrect. Log in using the form',
    invalidLoginData: 'The login data provided is incorrect.',
    login: 'Log in',
    logging: 'Logging in...',
    noAccount: 'No account?',
    password: 'Password',
    passwordChanged: 'Your password has been changed. You can now log in with your new password.',
    passwordReminder: 'Password reset',
    registerForFree: 'Sign up and use for free!',
    title: 'Online Booking System',
    yourEmail: 'Enter your e-mail address',
    yourPassword: 'Enter your password'
  },
  integrationPopup: {
    title: 'Plugin code'
  },
  integrations: {
    apiKey: 'API Key',
    dontShareAPIKey: 'Please do not share your API key with unauthorized people, as it allows you to manage your reservations without providing login data.',
    downloadIntegrationCode: 'Download code',
    downloadInstallationFile: 'Download plugin',
    fbDesc1: 'To integrate website with Facebook you must have website enabled. Enable it in ',
    fbDesc2: ' by changing value of the "My website" to YES. Then under settings please go to My website and please select your subdomain. You will be able to fully edit your website under tab My website in the Bookero main menu.',
    fbDescBtn: 'settings',
    fbTitle: 'Integration with Facebook',
    fbIntroText: 'Integration with Facebook is used to redirect user with dedicated CTA button to the page with reservation form.',
    fbIntroTitle: 'How to enable integration?',
    fbIntroDescBtn: 'Read how to do it',
    fbIntroDescBtnClose: 'Hide tutorial',
    fbIntroDesc1: 'While logged in on FB, click on the shortcut menu button under the edit page button.',
    fbIntroDesc2: 'Select "Edit action button" from the expanded list.',
    fbIntroDesc3: 'Then click on the "Change button" button.',
    fbIntroDesc4: 'Select "Contact us" from the expanded list and then click on the "Next" button.',
    fbIntroDesc5: 'Enter the address of the site where the booking form is located in the dedicated field and save the change.',
    fbIntroDesc6: 'Done!',
    inlineBoxTitle: 'Inline Box',
    inlineBoxDesc1: 'The Inline Box plugin adds a reservation form in the place you have indicated on the site. Place a <code>div</code> container with the <code>id</code> attribute equal to <code>bookero</code> in the selected place.',
    inlineBoxDesc2: 'Then place the downloaded integration code just before closing the <code>&lt;/body&gt;</code> section.',
    inlineBoxDesc3: 'If you want to set your own css styles for forms, change the plugin_css parameter to false.',
    inlineBoxDesc4: 'If you want to set your own css styles for forms, change the value of the bookero_plugin_css parameter to false.',
    joomlaTitle: 'Joomla',
    joomlaDesc1: 'If you are using Joomla!, you can use our plugin to display the reservation form.',
    joomlaDesc2: 'Download the installation file and upload it to your system using the extension installer. Go to add-ons list and publish Bookero plugin.',
    joomlaDesc3: 'In plugin configuration paste plugin ID to the field with the same name.',
    pluginID: 'Plugin ID',
    monthlyBoxTitle: 'Monthly Box',
    monthlyBoxDesc1: 'The Monthly Box plugin adds a reservation form in the place you specify on the site. Place a <code>div</code> container with the <code>id</code> attribute equal to <code>bookero</code> in the chosen place.',
    monthlyBoxDesc2: 'Then place the downloaded integration code just before closing the <code>&lt;/body&gt;</code> section.',
    monthlyBoxDesc3: 'If you want to set your own css styles for forms, change the plugin_css parameter to false.',
    monthlyBoxDesc4: 'If you want to set your own css styles for forms, change the value of the bookero_plugin_css parameter to false.',
    productsBoxTitle: 'Products Box',
    productsBoxDesc1: 'The Products Box plugin adds a pass buying form in the place you specify on the site. Place a <code>div</code> container with the <code>id</code> attribute equal to <code>bookero</code> in the chosen place.',
    productsBoxDesc2: 'Then place the downloaded integration code just before closing the <code>&lt;/body&gt;</code> section.',
    productsBoxDesc3: 'If you want to set your own css styles for forms, change the plugin_css parameter to false.',
    productsBoxDesc4: 'If you want to set your own css styles for forms, change the value of the bookero_plugin_css parameter to false.',
    stickyBoxTitle: 'Sticky Box',
    stickyBoxDesc1: 'The Sticky Box plugin adds a reservation form in the fixed position of the page, attached to the bottom edge of the browser.',
    stickyBoxDesc2: 'You don\'t have to add any additional <code>&lt;div&gt;</code> container.',
    stickyBoxDesc3: 'Simply place the downloaded integration code just before closing the <code>&lt;/body&gt;</code> section.',
    stickyBoxDesc4: 'If you want to set your own css styles for forms, change the plugin_css parameter to false.',
    stickyBoxDesc5: 'If you want to set your own css styles for forms, change the value of the bookero_plugin_css parameter to false.',
    title: 'Integrations',
    warning: 'Attention!',
    webWaveTitle: 'Integration with WebWave CMS',
    webWaveStep1Title: 'Step 1.',
    webWaveStep1Desc: 'To add a form to your website on webwavecms.com go into its edition and click the <strong>"Any HTML, CSS, JS"</strong> button available on the left side of the feature list.',
    webWaveStep2Title: 'Step 2.',
    webWaveStep2Desc: 'In the middle of the <strong> page you will see a field</strong> in the shape of a green square, whose size and position can be freely changed. Clicking on it will display a <strong>window with the HTML</strong> editor, to which <strong> we paste the appropriate code</strong> depending on what kind of plugin we want to use on the page.',
    webWaveStep3Title: 'Step 3.',
    webWaveStep3Desc: 'After pasting the code according to the instructions available in the <strong>"Integration"</strong> tab, click the green <strong>"Change code"</strong> button, and after closing the window, click the <strong>"Publish"</strong> button available in the upper menu. The content of the HTML element will be visible <strong> only on the published page</strong>.',
    webWaveStep4Title: 'Ready!',
    webWaveStep4Desc: 'On the page where we placed the field we will see a <strong>reservation form</strong> Bookero.',
    weeklyBoxTitle: 'Weekly Box',
    weeklyBoxDesc1: 'The Weekly Box plugin adds a booking form in the place you specify on the site. Place a <code>div</code> container with the <code>id</code> attribute equal to <code>bookero</code> in the chosen place.',
    weeklyBoxDesc2: 'Then place the downloaded integration code just before closing the <code>&lt;/body&gt;</code> section.',
    weeklyBoxDesc3: 'If you want to set your own css styles for forms, change the plugin_css parameter to false.',
    weeklyBoxDesc4: 'If you want to set your own css styles for forms, change the value of the bookero_plugin_css parameter to false.',
    wpTitle: 'WordPress',
    wpDesc1: 'If you are using WordPress, you can use our plugin to display the reservation form.',
    wpDesc2: 'Download the installation file and upload it to your system using the plugin installer. Activate the Bookero plugin and proceed to configuration.',
    wpDesc3: 'In the plugin configuration, paste the Key API into a field with the same name'
  },
  inquiriesCheckPopup: {
    actionRequired: 'Action required',
    changesWillBeAppliedDuringSave: '<strong>Note!</strong> Changes to reservations will only be applied when all changes are saved.',
    changeDateTo: 'Change date to',
    changeIssueDesc: 'Some reservations could not be updated',
    changeIssueTitle: 'Some changes require correction',
    changesSummary: {
      cancel: 'Cancelled',
      date: 'Date changes',
      noChanges: 'No changes',
      title: 'Summary of changes',
      worker: 'Worker changes'
    },
    changeTerm: 'Change date',
    changeWorker: 'Change worker',
    changeWorkerTo: 'Change the worker for this reservation to',
    confirmChanges: 'Confirm changes',
    dateWillBeChangedTo: 'Date will be changed to:',
    noChanges: 'No changes',
    notifyClients: 'Notify clients',
    reservationWillBeCancelled: 'The reservation will be cancelled',
    reservationWillBeLeftWithoutChanges: 'The reservation will remain unchanged',
    revert: 'undo',
    saving: 'Saving changes',
    selectWorker: 'Select worker',
    title: 'You have reservations that require changes',
    waitingForChange: 'Pending changes',
    workerWillBeChangedTo: 'Worker will be changed to:'
  },
  invoiceDetailsPopup: {
    address: 'Address',
    amount: 'Net amount',
    companyTitle: 'Customer name',
    errorMessageDesc: 'An error occurred while retrieving invoice data',
    errorMessageTitle: 'An error occurred',
    gtu: 'GTU',
    issueDate: 'Issue date',
    itemAmount: 'Net price',
    itemPrice: 'Net price per unit',
    itemTotal: 'Gross price',
    itemVAT: 'VAT',
    name: 'Produkt',
    nip: 'Tax Number',
    notes: 'Notes',
    onInvoice: 'On invoice',
    onReceipt: 'On receipt',
    paymentDate: 'Payment date',
    inquiryStatus: 'Reservation status',
    paymentStatus: 'Payment status',
    paymentType: 'Payment method',
    qty: 'Qty',
    titleInvoice: 'Invoice details {number}',
    titleReceipt: 'Receipt details {number}',
    vat: 'VAT amount'
  },
  invoices: {
    amount: 'Amount',
    companyName: 'Document Recipient',
    dueDate: 'Due Date',
    inquiries: 'Inquiries',
    isCompany: 'For Whom?',
    issueDate: 'Issued',
    listItem: {
      company: 'Company',
      create: 'Generate document',
      customer: 'Individual',
      delete: 'Delete',
      download: 'Download',
      errorNotCreated: 'An error occurred during generating the document. Please try again.',
      errorNotCreatedDesc: 'An error occurred during document integration: ',
      invoice: 'VAT Invoice',
      invoiceNotRemoved: 'Failed to remove the document',
      invoiceRemoved: 'Document successfully removed',
      receipt: 'Receipt',
      removeConfirmTitle: 'Deleting document',
      removeConfirmDesc: 'Are you sure you want to delete this document?',
      removeConfirmIntegratedInvoiceTitle: 'This document is already integrated',
      removeConfirmIntegratedInvoiceDesc: 'Are you sure you want to delete this document?',
      seeDetails: 'See Details'
    },
    noInvoices: 'No sales documents...',
    noInvoicesForGivenFilters: 'No sales documents meet the given criteria...',
    number: 'Number',
    statuses: {
      all: 'All documents',
      issued: 'Issued documents',
      notReady: 'Incomplete documents',
      ready: 'Documents ready to be issued'
    },
    title: 'Sales documents',
    type: 'Type',
    types: {
      all: 'Invoices and receipts',
      invoices: 'Only invoices',
      receipts: 'Only receipts'
    }
  },
  myPage: {
    banner: 'Banner',
    bannerType: 'Banner type',
    darkText: 'Dark',
    dynamicSize: 'Dynamic size',
    fullScreen: 'Full screen',
    galleryType: 'Gallery type',
    galleryTypeBig: 'Big photos',
    galleryTypeSmall: 'Small photos with ability to zoom',
    galleryTypeLogo: 'Partners gallery',
    lightText: 'Clear',
    textColor: 'Text shade'
  },
  myPageSection: {
    addColumn: 'Add a column',
    addRow: 'Add a line',
    background: 'Background',
    bgAndContactData: 'Background and contact details',
    buttonText: 'Button label:',
    buttonUrl: 'Button URL:',
    buttonTargetBlank: 'Open link in a new window',
    category: 'Category',
    category1: 'Category 1',
    columnContent: 'Content of the column',
    containerType: 'Type of container',
    dark: 'Dark',
    dragAndDropImageHere: 'Drag and drop the image here',
    heading: 'Header',
    image: 'Picture',
    imageAlignment: 'Alignment of image',
    imageRemoved: 'The image have been deleted',
    imageType: 'Type of image',
    inlineBoxForm: 'Inline Box form',
    productsForm: 'Pass purchase',
    left: 'Left',
    light: 'Clear',
    loadingData: 'Loading data...',
    loadingEditor: 'The editor\'s loading...',
    loadingImages: 'Loading images...',
    mapAndContactData: 'Map and contact details',
    monthlyBoxForm: 'Form of the Monthly Box type',
    name: 'Name',
    noImagesInGallery: 'No pictures in the gallery...',
    or: 'or',
    removeBanner: 'Remove banner',
    removeBackgroundImage: 'Delete background images',
    removeImage: 'Delete image',
    removeInProgress: 'Removing...',
    removeSectionTitle: 'Deleting section',
    removeSectionDesc: 'Are you sure you want to delete the selected section?',
    removeSectionButton: 'Delete a section',
    right: 'Right',
    savingSection: 'Saving section configurations...',
    sectionAdditionalContent: 'Additional content',
    sectionBackgroundImage: 'Background image',
    sectionDescription: 'Additional text under title:',
    sectionImage: 'Image',
    sectionTitle: 'Section title',
    selectedSectionNotSaved: 'The selected section has not been saved. Please try again.',
    selectedSectionRemoved: 'The selected section has been deleted',
    selectedSectionSaved: 'The selected section has been saved',
    selectFiles: 'Select files',
    showOpeningHoursTitle: 'Show opening hours',
    showSectionTitle: 'Show section title:',
    showServiceTime: 'Show service times:',
    showServicePrice: 'Show service prices:',
    submitNewFileToChangeBackgroundImage: 'Send a new file to change the background image',
    submitNewFileToChangeBanner: 'Send new file to change banner',
    submitNewFileToChangeImage: 'Send a new file to change the image',
    visibilityInMenu: 'Visibility in menu:',
    textColor: 'Text shade',
    types: {
      text: 'Text page',
      banner: 'Banner',
      gallery: 'Gallery',
      pricelist: 'Price list',
      reservation: 'Booking + Contact',
      textimage: 'Text page + Image',
      services: 'Services list',
      workers: 'Workers list'
    },
    uploadInProgress: 'Uploading...',
    weeklyBoxForm: 'Weekly Box form'
  },
  myPageSectionPopup: {
    addSection: 'Add a section',
    addSectionTitle: 'Add a section of the page',
    bannerSection: 'Banner',
    gallerySection: 'Gallery',
    newSectionAdded: 'A new section has been added',
    newSectionNotAdded: 'The new section has not been added',
    pricingSection: 'Price list',
    reservationSection: 'Booking + Contact',
    sectionName: 'Section name',
    sectionNameIsRequired: 'Section name is required',
    sectionType: 'Type of section',
    sectionTypeIsRequired: 'Section type is required',
    selectSectionType: 'Select the type of section',
    servicesSection: 'Services list',
    showInMenu: 'Show in the menu',
    textImageSection: 'Text page + Image',
    textSection: 'Text page',
    workersSection: 'Workers list'
  },
  news: {
    allNewsMarkedAsRead: 'All news are now marked as readed',
    collapse: 'Collapse',
    loadingNews: 'Loading news...',
    markAllAsRead: 'Mark all as read',
    readMore: 'Read more',
    title: 'New features in Bookero',
    unreaded: 'Unreaded',
    youHaveUnreadedNews: 'No unreaded information | {n} unreaded information | {n} unreaded informations'
  },
  noPermissions: {
    title: 'No permissions...',
    desc: 'You are not authorized to browse this site'
  },
  notifications: {
    all: 'All',
    emptyState: 'No notification',
    markAllAsRead: 'Mark all as read',
    onlyUnread: 'Only unread ({unreadCount})',
    pleaseWait: 'Wait...'
  },
  openingHours: {
    applyRule: 'Apply the rule',
    applyToAll: 'Apply: all',
    applyToOnce: 'Apply: once time',
    applyToTwoWeeks: 'Apply: two weeks',
    applyToEveryYear: 'Apply: repeat every year',
    date: 'Date',
    newCompanyRule: 'New company rule',
    newWorkerRule: 'New employee rule',
    noOpeningHoursRules: 'No opening rules were found...',
    noWorkerOpeningHoursRules: 'No worker working hours rules were found...',
    rule: 'Rule',
    ruleAll: 'Rule: all',
    ruleAppliesTo: 'The rule applies to',
    ruleChangedWorkHours: 'Rule: change work hours',
    ruleFreeDay: 'Rule: free days',
    ruleForAll: 'Rule for: all',
    ruleForCompany: 'Rule for: company',
    ruleForWorker: 'Rule for: employee',
    showActive: 'Show: active',
    showAll: 'Show: all',
    showOutdated: 'Show: outdated',
    title: 'Opening rules'
  },
  openingHoursCompanyForm: {
    addTitle: 'Adding the rule of company opening hours',
    applyRule: 'Apply the rule:',
    basicData: 'Basic data',
    changeWorkHours: 'Change of working hours',
    dateRange: 'Range of dates:',
    editTitle: 'Editing the rule of company opening hours',
    forRulesRepeatingEveryYearDescription: 'For rules that are repeated every year, the working hours common to all days in the selected date range should be specified. If you need to define different opening hours for each day, create separate rules for each day of the date range.',
    modifiedWorkHours: 'Modified company working hours',
    noCategory: 'No category',
    onceTime: 'Once time',
    repeatEveryYear: 'Every year',
    rule: 'Rule:',
    ruleAdded: 'The rule has been added',
    ruleDataChanged: 'The rules concerned have been changed',
    startFrom: 'Start from:',
    twoWeeks: 'Every two weeks'
  },
  openingHoursCompanyService: {
    availabilityTheSameAsCompanyHours: 'Availability same as company hours'
  },
  openingHoursListItem: {
    applyRule: 'Apply the rule:',
    changedWorkHours: 'Change of working hours',
    company: 'Company',
    editRule: 'Edit the rule',
    onceTime: 'Once time',
    removeRule: 'Delete the rule',
    removeRuleTitle: 'Deleting the opening rule',
    removeRuleDesc: 'Are you sure you want to delete a selected opening rule?',
    removeRuleBtn: 'Delete the rule',
    removedRule: 'The selected rule has been deleted',
    repeatsEveryTwoWeeks: 'Is is repeated every two weeks',
    repeatsEveryYear: 'It is repeated every year',
    rule: 'Rule:',
    rulesAppliesTo: 'The rule applies to:',
    since: 'from:',
    to: 'to:'
  },
  openingHoursWorkerForm: {
    addRuleTitle: 'Adding an employee\'s working hours rule',
    applyRule: 'Apply the rule:',
    basicData: 'Basic data',
    changedWorkHours: 'Change of working hours',
    dateRange: 'Range of dates:',
    editRuleTitle: 'Editing the employee\'s working hours rule',
    everyYear: 'Every year',
    forRulesRepeatedEveryYearDescription: 'For rules that are repeated every year, the working hours common to all days in the selected date range should be specified. If you need to define different opening hours for each day, create separate rules for each day of the date range.',
    modifiedWorkHours: 'Modified working hours',
    onceTime: 'Once time',
    rule: 'Rule:',
    ruleAdded: 'The rule has been added',
    ruleDataChanged: 'The rules data has been changed',
    selectWorker: 'Select an employee',
    selectWorkerToSpecifyWorkHour: 'Select an employee to specify the working hours...',
    startFrom: 'Start from:',
    twoWeeks: 'Every two weeks',
    youMustSelectWorker: 'You must select a worker',
    worker: 'Employee:'
  },
  openingHoursWorkerPopup: {
    saveChanges: 'Save changes',
    savingChanges: 'Saving changes'
  },
  passes: {
    calculatedByReservationsCount: 'Limits calculated according reservations count',
    calculatedByPeoplesCount: 'Limits calculated according peoples count',
    days: 'days | day | days | days',
    due: ' for ',
    editPass: 'Edit pass',
    expired: 'Expired',
    minutes: 'minutes | minute | minutes | minutes',
    months: 'months | month | months | months',
    name: 'Pass name',
    newPass: 'Add new pass',
    noPasses: 'No passes...',
    noPassesForGivenFilters: 'No passes were found that meet the criteria...',
    orderingSaved: 'The order of passes has been saved',
    price: 'Pass price',
    removedPass: 'Selected pass removed',
    removePass: 'Remove pass',
    removePassBtn: 'Remove pass and related purchased passes',
    removePassDesc: 'Do you want to remove the selected pass? All purchased passes linked to this pass type will also be removed. This operation cannot be undone.',
    removePassTitle: 'Pass removal',
    salePeriod: 'Sale period',
    salePeriodFrom: 'from {date}',
    salePeriodTo: 'until {date}',
    saleStatus: {
      active: 'On sale',
      activeTo: 'On sale until {date}',
      before: 'On sale from {date}',
      ended: 'Sale ended'
    },
    services: 'Available services',
    times: 'times | time | times | times',
    title: 'Passes',
    type: 'Pass type',
    types: {
      all: 'All types',
      days: 'Pass for a specific number of days',
      duration: 'Pass for a specific number of minutes',
      months: 'Pass for a specific number of months',
      usage: 'Pass for a specific number of uses'
    },
    usage: 'To use',
    validity: 'Validity from activation'
  },
  passesActive: {
    changePaymentStatus: 'Change payment status',
    code: 'Pass code',
    editPass: 'Edit pass',
    left: 'To use',
    inquiries: 'Reservations',
    inquiriesCount: 'reservations | reservation | reservations | reservations',
    newPass: 'Add new pass',
    noPasses: 'No active passes...',
    noPassesForGivenFilters: 'No active passes were found that meet the criteria...',
    pass: 'Pass type',
    passCode: 'Pass code',
    payment: 'Payment',
    paymentStatus: {
      isAutoRenew: 'Auto-renewal',
      isNotAutoRenew: 'No renewal',
      isNotPaid: 'Unpaid',
      isPaid: 'Paid'
    },
    period: 'Validity',
    publishPass: 'Activate pass',
    removedPass: 'Pass removed',
    removePass: 'Remove pass',
    removePassBtn: 'Remove pass',
    removePassDesc: 'Do you want to remove the selected pass? This operation cannot be undone.',
    removePassTitle: 'Pass removal',
    searchCustomer: 'Search by customer',
    searchPass: 'Search by pass type',
    selectedPassPublished: 'Selected pass activated',
    selectedPassStateError: 'Failed to change pass state',
    selectedPassUnpublished: 'Selected pass deactivated',
    status: 'Status',
    thisPassIsInactive: 'This pass is currently inactive',
    thisPassIsWaiting: 'This pass is waiting to start',
    title: 'Purchased passes',
    toPostpone: 'Available date changes',
    unpublishPass: 'Deactivate pass'
  },
  passesActiveForm: {
    addTitle: 'Add purchased pass',
    allServices: 'All services',
    amountToPostpone: 'Reservation cancellation limit',
    basePassHasBeenModifiedSoNewConfigWillBeAppliedToThisPass: 'The configuration of the selected pass type has changed since this purchased pass was created. Updated settings from the pass type will be applied to this purchase. If you want to keep the original settings, refresh the page and do not change the pass type.',
    comparisionIntro: 'Below is a comparison of the configuration used by this pass with the current configuration for this type of passes. Changes are highlighted in red.',
    customer: 'Customer',
    customerIsInvalid: 'You must select a customer',
    currentConfig: 'Current configuration',
    editTitle: 'Editing purchased pass',
    isPaid: 'Pass paid?',
    originalConfig: 'Saved configuration',
    outsideSalePeriod: 'outside the sale period',
    pass: 'Pass type',
    passIntro: 'Below is the currently used pass configuration',
    passesIsInvalid: 'You must select a pass type',
    passParams: 'Purchased pass parameters',
    validFrom: 'Active from',
    validFromIsInvalid: 'You must select the pass start date',
    validTo: 'Active to'
  },
  passesForm: {
    addTitle: 'Add pass',
    amountCountedBy: 'Calculate limits according to',
    amountToPostpone: 'Reservation cancellation limit within the pass',
    amountToPostponeNote: 'Defines how many reservations the user can cancel within the pass',
    amountToUseMinutes: 'Minutes limit to use',
    amountToUseUsage: 'Usage count limit',
    amountToUseTime: 'Time limit of use',
    availableByHours: 'Active at specific hours',
    availableByHoursNote: 'If this option is enabled, the pass will be available only during selected hours (reservation hour decides)',
    byPeoplesCount: 'peoples count',
    byReservationsCount: 'reservations count',
    days: 'days | day | days | days',
    description: 'Pass description',
    editTitle: 'Edit pass',
    hasPriceLimit: 'Set price limit for reservation',
    hasSalePeriod: 'Limit the sale period',
    hasSalePeriodNote: 'Outside the sale period the pass will not be visible in the plugin and it will not be possible to order it. The purchase day decides and the given dates are included in the sale period.',
    hoursRange: 'Pass active during hours',
    minutes: 'minutes | minute | minutes | minutes',
    months: 'months | month | months | months',
    name: 'Pass name',
    noPaidParams: 'No paid parameters available',
    paramAdminOnly: 'visible only in panel',
    parametersTitle: 'Paid parameters',
    parametersToPay: 'Paid parameters despite pass',
    parametersToPayNote: 'Enable this option if you want selected extra paid parameters to always require payment, regardless of pass usage.',
    paramsDesc: 'If you check parameters below, they will be paid despite having a pass.',
    paramUnpublished: 'unpublished',
    passAdded: 'Pass created',
    passChanged: 'Pass modified',
    passParams: 'Basic data',
    paymentMethodsForThePass: 'Payment methods for the pass',
    price: 'Pass price',
    priceLimit: 'Price limit for reservation',
    reservationsWithinValidity: 'Reservations only within the pass validity period',
    reservationsWithinValidityNote: 'The customer will be able to use the pass only for reservation dates before the end of the pass validity',
    saleFrom: 'Sale from',
    salePeriodDateRequired: 'Provide at least one of the sale period dates',
    salePeriodEmptyDateNote: 'Leave empty for no limit',
    salePeriodTitle: 'Sale period',
    saleTo: 'Sale to',
    saleToBeforeSaleFrom: 'The sale end date cannot be earlier than the sale start date',
    selectType: 'Select pass type',
    servicesDesc: 'If you do not select any service, the pass will work for all services',
    servicesTitle: 'Services related to the pass',
    type: 'Pass type',
    updateActivePasses: 'Save changes also for already purchased passes',
    validityDays: 'Pass validity from the activation day',
    validityDaysNote: 'Specifies how many days the pass is valid from the time of activation',
    whyParamIsPaid: 'Why is this parameter paid?'
  },
  passwordReminder: {
    anErrorOccurred: 'There was a problem with resetting the password - try again.',
    backToLogin: 'Return to the login form',
    emailIsRequired: 'Filling in the field with the e-mail address is required to reset the password.',
    ifEmailExistLinkSent: 'If the given e-mail address exists in our database, a link leading to the password change form has been sent to it.',
    invalidEmail: 'The e-mail address provided is incorrect',
    provideEmailConnectedWithAccount: 'Enter the email address associated with your account to reset your password:',
    reset: 'Reset password',
    resetting: 'Resetting...',
    title: 'You forgot your password?',
    yourEmail: 'Please enter your e-mail address',
    wantToLogin: 'You want to log in?'
  },
  passwordReset: {
    backToLogin: 'Return to the login form',
    bothFieldsRequired: 'Both fields with passwords must be filled.',
    differentPasswords: 'The passwords given are not identical',
    invalidPasswords: 'The passwords given are incorrect - the password must be at least 6 characters long.',
    invalidToken1: 'Incorrect token. Click the link from the email you received again or',
    invalidToken2: 'reset your password',
    invalidToken3: 'once again.',
    newPassword: 'New password:',
    repeatPassword: 'Repeat the password',
    reset: 'Reset password',
    resetting: 'Resetting is in progress...',
    resetError: 'There was a problem with resetting the password - try again.',
    title: 'Resetting the password,',
    wantToLogin: 'You want to log in?',
    yourNewPassword: 'Your new password',
    yourRepeatedPassword: 'Repeat the password'
  },
  paymentMethodForm: {
    addTitle: 'Adding the payment method',
    apiAuthToken: 'API authorization token:',
    basicPrice: 'Basic price:',
    cash: 'Cash',
    code: 'Code:',
    configureServicesTitle: 'Configure services using this payment method',
    configurePassesTitle: 'Configure passes using this payment method',
    configureTitle: 'Configure payment processing',
    crcKey: 'CRC key:',
    editTitle: 'Editing the payment method',
    forPerson: 'per person',
    forReservation: 'per reservation',
    hash: 'Hash:',
    key: 'API key:',
    merchantID: 'Merchant ID:',
    name: 'Name of the payment method:',
    paymentType: 'Type of payment:',
    password: 'Password:',
    paymentCurrency: 'Currency of payment:',
    paymentMethodAdded: 'The payment method has been added',
    paymentMethodNotSaved: 'An error occurred during saving payment method',
    paymentMethodSettingsSaved: 'The payment method settings have been changed',
    posID: 'Payment point id (pos_id)',
    pin: 'PIN:',
    privateKey: 'Secret Key',
    publicKey: 'Public Key',
    receiverID: 'Recipient identifier:',
    redirectDescription: 'This is the address of the page to which the customer is redirected after payment.<br>This address should start with "http://" or "https://"',
    redirectFailedDescription: 'This is the address of the page to which the customer is redirected after failed payment.<br>This address should start with "http://" or "https://"',
    returnUrl: 'Return URL after payment:',
    returnFailedUrl: 'Return URL after failed payment:',
    returnFailedUrlDesc: 'Currently this payment method does not support this feature.',
    secondaryKeyMD5: 'Second key (MD5):',
    secret: 'Signature Key:',
    sellerID: 'Vendor ID:',
    serviceID: 'Shop ID:',
    serviceKey: 'Shop key:',
    shopID: 'Store ID:',
    signature: 'Signature:',
    timeInHoursForPayment: 'Time in hours for payment:',
    timeInHoursForPaymentDesc: 'If time in hours is equal to 0, the time for payment won\'t be applied.',
    timeMustBeBiggerEqualThanZero: 'Time for payment cannot be smaller than zero.',
    username: 'Username:',
    visibleOnlyForAdmin: 'Only visible to the administrator',
    youCannotHideThisPaymentMethodAsItIsDefaultMethod: 'You cannot hide this payment method because it is the default payment method.'
  },
  payments: {
    additionalInformation: 'Additional information',
    buyer: 'Buyer',
    client: 'Customer',
    cost: 'Cost',
    date: 'Date',
    exportAs: 'Export as',
    filePrefix: 'payments.',
    noTransactions: 'No transactions were found...',
    noTransactionsForGivenCriteria: 'No transactions were found that meet the criteria...',
    pass: 'Pass',
    service: 'Service',
    status: 'Status',
    statusAdvanced: 'Partially paid',
    statusCanceled: 'Cancelled',
    statusCompleted: 'Completed',
    statusNew: 'New',
    statusPending: 'During the settlement',
    title: 'Transaction history',
    transactionStatus: 'Transaction status',
    worker: 'Employee'
  },
  paymentsListItem: {
    advancedReservation: 'Partially paid',
    call: 'Call',
    cartID: 'Cart ID:',
    category: 'Category: ',
    cancelledReservation: 'Cancelled',
    cardRegistered: 'Registered card',
    change: 'Change',
    clientNotPresent: 'Customer absent',
    completedReservation: 'Completed',
    date: 'Purchase date',
    formSent: 'The form was sent:',
    newReservation: 'New',
    paymentCollected: 'Payment charged',
    paymentMethod: 'Method of payment: ',
    paymentRegistered: 'Registration of payment',
    pendingReservation: 'During the settlement',
    reservationDetails: 'Reservation details',
    reservationParentDetails: 'Parent reservation #{id}',
    seeMore: 'See more',
    sendEmail: 'Send e-mail',
    workerCommission: 'Worker commission: '
  },
  paymentStatusPopup: {
    changeStatus: 'Change status',
    inquiryIsCyclic: 'By changing status, you change status for the whole reservations cycle, not only for this single reservation.',
    notifyClient: 'Notify the customer:',
    saving: 'Saving...',
    status: 'Status:',
    statusAdvanced: 'Partially paid',
    statusCancelled: 'Cancelled',
    statusChanged: 'The payment status has been changed',
    statusCompleted: 'Completed',
    statusNew: 'New',
    statusPending: 'During the settlement',
    title: 'Change payment status',
    warning: 'Warning!'
  },
  priceRules: {
    addNewRule: 'Add a new rule',
    newPrice: 'New price',
    noPriceRules: 'No price rules were found...',
    priceChangeDependsOn: 'The price change depends on:',
    rulesOrderingAffectsPriority: 'The order of rules determines their priority',
    rulesOrderingSaved: 'The order of the rules has been saved',
    title: 'Price rules',
    warning: 'Attention!'
  },
  priceRulesListItem: {
    additionalParams: 'Additional parameters:',
    anyValue: 'any value',
    daysCount: 'Number of days:',
    editRule: 'Edit the rule',
    newPrice: 'New price:',
    removePriceRuleTitle: 'Removal of the price rule',
    removePriceRuleDesc: 'Are you sure you want to delete the selected price rule?',
    removePriceRule: 'Delete the rule',
    removeRule: 'Delete the rule',
    reservationDay: 'Reservation day:',
    reservationHour: 'Time of reservation:',
    selectedRuleHasBeenRemoved: 'The selected rule has been deleted'
  },
  priceRulesForm: {
    addTitle: 'Adding a price rule',
    childrenNumberRange: 'Range of children:',
    considerAlso: 'Include:',
    daysLengthRange: 'Range of days number:',
    dateRange: 'Range of dates:',
    daysRange: 'Range of days:',
    dayOfReservation: 'The day for which the reservation is made',
    dayWhenReservationWasSent: 'Date of reservation',
    dependsFromAdditionalParams: 'Depending on additional parameters:',
    dependsFromChildrenNumber: 'Depending on the number of children:',
    dependsFromDate: 'Depending on the date of reservation:',
    dependsFromDay: 'Depending on the day of reservation:',
    dependsFromDaysLength: 'Depending on the days number:',
    dependsFromHour: 'Depending on the time of reservation:',
    dependsFromPeopleNumber: 'Depends on the number of people:',
    dependsFromWorkers: 'Depends on employees:',
    editTitle: 'Editing the price rule',
    everyWeek: 'Every week',
    everyTwoWeeks: 'Every two weeks',
    everyFourWeeks: 'Every four weeks',
    everyDay: 'Every day',
    hoursRange: 'Range of hours:',
    newPrice: 'New price:',
    newPriceWithDash: 'New price -',
    noServiceParameters: 'No parameters associated with the selected service',
    paramsTitle: 'Rule parameters',
    parameterValues: 'Parameter values:',
    periodicity: 'Periodicity:',
    peopleNumberRange: 'Range of people:',
    priceRuleAdded: 'The price rule has been added',
    priceRuleDataChanged: 'The price rule data has been saved',
    requiredConditionsForTheRule: 'Conditions required to comply with the rule',
    selectValue: 'Choose a value',
    workersDoingService: 'Employees doing the selected service',
    youMustSelectAtLeastOneDay: 'You must choose at least one day',
    youMustSelectAtLeastOneParam: 'You must select at least one parameter',
    youMustSelectServiceToSelectWorkers: 'You mast select the service first'
  },
  register: {
    acceptingTosIsRequired: 'Acceptance of the Terms of Service is required for registration.',
    allFieldsAreRequired: 'Completion of all fields and acceptance of ToS is required to register.',
    anErrorOccurred: 'There was an error during registration. Please check your connection to the Internet and try again.',
    companyName: 'Company name:',
    doYouHaveAnAccount: 'You already have an account?',
    email: 'E-mail address:',
    gdprText: '',
    login: 'Log in',
    optional: '(optional field)',
    password: 'The password',
    passwordsAreDifferent: 'The passwords given are not identical',
    passwordMustHave6Chars: 'The password must consist of at least 6 characters.',
    phone: 'Phone number:',
    register: 'Register',
    repeatPassword: 'Repeat the password:',
    sending: 'Sending...',
    someFieldsAreInvalid: 'Some fields are filled in incorrectly.',
    title: 'Start your 14-day free trial',
    tosText: 'I have read <a href="{tosUrl}" target="_blank">Terms of Service</a> and <a href="{ppUrl}" target="_blank">Privacy Policy</a> of Bookero and I accept their terms and conditions.',
    yourCompanyName: 'Enter your company name',
    yourEmail: 'Enter your e-mail address',
    yourPassword: 'Enter your password',
    yourPhone: 'Enter the phone number',
    yourRepeatedPassword: 'Repeat your password'
  },
  reservation: {
    acceptReservation: 'Accept the reservation',
    andService: 'and service',
    cancelReservation: 'Cancel the reservation',
    category: 'Category: ',
    cardRegistered: 'Registered card',
    clientNotPresent: 'The client didn\'t show up',
    clientNotPresentTitle: 'The client didn\'t come?',
    clientNotPresentDesc: 'If the customer did not show up, click Yes to write it down in his statistics.',
    clientNotPresentBtn: 'Yes, the customer didn\'t show up',
    clientNotPresentSaved: 'The absence of the client was saved',
    contactWithClient: 'Contact the customer',
    dateFormat: 'dddd, D MMMMM YYYY',
    forThisHour: 'For this hour ',
    id: 'Reservation ID',
    inProgress: 'Ongoing',
    moreInfoAboutReservation: 'Find out more about the reservation',
    moreInfoAboutBlockedDate: 'Find out more about the blocked date',
    noPeopleInThisTerm: 'No people at that time',
    paid: 'Paid',
    peopleCounter: 'ppl.',
    rejectReservation: 'Reject the reservation',
    reservations: 'reservations',
    unblockDate: 'Unblock date',
    unpaid: 'Unpaid',
    youHave: 'you have:'
  },
  reservationsCart: {
    betweenStart: 'Between',
    betweenMiddle: 'and',
    seeCart: 'See the cart',
    totalCost: 'Total cost:'
  },
  reservationsCartPopup: {
    acceptAll: 'Accept all',
    emailNotificationsSent: 'An e-mail notification was sent to the client',
    manualAcceptRequiredDesc: 'Some reservations were not automatically accepted.',
    manualAcceptRequiredTitle: 'Manual acceptance required',
    rejectAll: 'Reject all',
    rejectPopupTitle: 'Reject inquiries',
    rejectPopupDesc: 'Do you want to reject these inquiries or add them to the waiting list?',
    rejectPopupCancelButton: 'Reject all',
    rejectPopupOkButton: 'Add all to waiting list',
    title: 'Reservation cart'
  },
  reservationDetails: {
    accepted: 'Accepted',
    acceptReservation: 'Accept the reservation',
    advancePrice: 'Advance quote:',
    appliedDiscountQuote: 'Discount quote:',
    appliedPassQuote: 'Pass quote:',
    attendance: 'Attendance',
    blockadeDescription: 'Description',
    blockedToDate: 'Expires:',
    blockedToDateCompanyBlockade: 'Blockade end:',
    blockingType: 'Blockade type',
    blockingTypeCalendarDaily: 'Calendar for daily services',
    blockingTypeCalendarHourly: 'Calendar for hourly services',
    blockingTypeService: 'Service',
    blockingTypeWorker: 'Worker',
    byAdministrator: 'administrator',
    byClient: 'customer',
    cancelled: 'Cancelled',
    cancelFutureWithoutPayments: 'Do you want to delete future reservations created during cycle of reservations? | Do you want to delete future reservations created during cycle of reservations? {count} reservation will be removed - from date {date} | Do you want to delete future reservations created during cycle of reservations? {count} reservations will be removed - from date {date}',
    cancelFutureWithPayments: 'Do you want to delete future unpaid reservations created during cycle of reservations? | Do you want to delete future unpaid reservations created during cycle of reservations? {count} reservation will be removed - from date {date} | Do you want to delete future unpaid reservations created during cycle of reservations? {count} reservation will be removed - from date {date}',
    cancelledAt: 'Cancellation date:',
    cancelledBy: 'Cancelled by:',
    cancelPeriodicity: 'cancel cycle renew',
    cancelPeriodicityConfirmDesc: 'Created reservations will remain in the system, but no new reservations will be created using periodicity configuration.',
    cancelPeriodicityConfirmTitle: 'Periodicity renew will be disabled',
    cancelReservation: 'Cancel the reservation',
    cart: 'Reservations cart',
    cartID: 'Cart ID:',
    cartLeftToPay: 'Left to pay',
    cartAdvanceLeftToPay: 'Advance left to pay',
    cartPaymentLink: 'Cart payment link:',
    cartPaymentQuote: 'Cart payment quote:',
    cartPaymentAdvanceQuote: 'Cart advance quote for cart:',
    cartTransactionID: 'Cart transaction ID:',
    cardRegistered: 'Registered card',
    category: 'Category:',
    changeDate: 'Change the date',
    changeIntoReservation: 'Change into reservation',
    changePaymentStatus: 'Change',
    clientNotPresent: 'Customer absent',
    clientNotPresentSaved: 'Changed status to absent',
    clientPresent: 'customer present',
    clientPresentReset: 'Attendance status cleared',
    clientPresentSaved: 'Changed status to present',
    copy: 'Copy',
    copyPaymentLink: 'Copy the payment link',
    copyGoogleMeetLink: 'Copy the Google Meet link',
    copyOutlookMeetLink: 'Copy the Outlook meeting link',
    createdAt: 'Date of creation:',
    createdBy: 'Created by:',
    customerEmail: 'Customer e-mail:',
    customerPhone: 'Customer phone:',
    emailAgreement: 'Consent to marketing activities via e-mail',
    filledSurveys: 'Filled surveys:',
    givenAgreements: 'Consents given:',
    googleCalendar: 'Google Calendar',
    googleMeetURL: 'Google Meet URL',
    importantInformation: 'Important information',
    importedFrom: 'Imported from:',
    invoiceOrReceipt: 'Sale document:',
    leftToPay: 'Left to pay:',
    lockmeReservationID: 'LockMe reservation ID:',
    minutes: 'min.',
    no: 'No',
    okCancelPeriodicity: 'OK, cancel periodicity',
    outlookCalendar: 'Outlook Calendar',
    outlookMeetURL: 'Outlook meeting URL:',
    noteFromCalendar: 'Calendar note',
    payment: 'Payment:',
    paymentCartStatus: 'Cart payment status:',
    paymentDate: 'Due date:',
    paymentLink: 'Link to payment:',
    paymentMethod: 'Method of payment:',
    paymentStatusAdvanced: 'Partially paid',
    paymentStatusNew: 'New',
    paymentStatusPending: 'During the settlement',
    paymentStatusCompleted: 'Completed',
    paymentStatusCancelled: 'Cancelled',
    paymentStatusCardRegistered: 'Registered card',
    paymentStatusPaymentRegistration: 'Registration of payments',
    paymentStatusPaymentCollected: 'Payment charged',
    paymentQuote: 'Amount of payment:',
    periodicity: 'Periodicity:',
    periodicityCancelFailed: 'Periodicity cancel failed - please try again.',
    phoneAgreement: 'Consent for marketing activities via telephone calls',
    rejected: 'Rejected',
    rejectReservation: 'Reject the reservation',
    reservedBy: 'Customer:',
    reservationDate: 'Date:',
    reservationDateCompanyBlockade: 'Blockade period:',
    reservationDuration: 'Duration:',
    reservationHour: 'Time:',
    reservationParams: 'Reservation parameters:',
    reservationParent: 'It is parent reservation of periodicity',
    reservationParentDetails: 'Parent reservation:',
    savingChanges: 'saving changes...',
    seeSurveyResults: 'See survey results',
    status: 'Status:',
    title: 'Reservation details',
    titleBlockedDate: 'Blocked date details',
    titleCompanyBlockedDate: 'Blocked calendar details',
    tosAndPrivacyPolicy: 'Accepted ToS and privacy policy',
    qrCodeTickets: 'QRCode tickets:',
    qrCodeTicketsDateOfUse: 'Dates of use:',
    usedDiscountCode: 'Used discount code:',
    usedPassCode: 'Used pass code:',
    usedQrCodeTickets: 'Used:',
    yes: 'Yes',
    reservationWaitingListNotificationDate: 'Notification about free term:',
    waitingList: 'Waiting list',
    waitsForAccept: 'Awaiting acceptance',
    waitsForPayment: 'Awaiting payment'
  },
  reservationForm: {
    addedNewPeriodicityDates: 'None | You increase reservation package by one additional termin | You increase reservation package by {count} additional termins',
    additionalInformations: 'Additional information',
    addNewPeriodicityDates: 'Add further termins',
    addNewPeriodicityDatesTitle: 'How many termins do you want to add?',
    addNewPeriodicityDatesDesc: 'Please specify how many termins do you want to add. Please remember, that you can have at max. 30 next termins in reservation.',
    addNewPeriodicityDatesLabel: 'How many termins?',
    addNewPeriodicityDatesOk: 'Add termins',
    addNewPeriodicityDatesErrorTitle: 'Unable to add termins',
    addNewPeriodicityDatesErrorDesc: 'You cannot add termins | You can add max. 1 termin | You can add max. {max} termins',
    advance: 'Advance:',
    annotations: {
      changedCurrency: 'Changed currency:',
      changedPrice: 'Changed price:',
      changedStatus: 'Changed status:',
      changedSystem: 'Changed payment method:',
      changedPayment: 'Changed payment method:',
      reservation: 'Reservation:',
      see: 'See reservations which are affected.'
    },
    anyWorker: 'Any employee',
    askForNewStatusTitle: 'An edited reservation has the status of a pending reservation. Do you want to change the status of this reservation while saving?',
    askForNewStatusBtnOk: 'Save and accept',
    askForNewStatusBtnCancel: 'Save as pending',
    basicDataTitle: 'Basic data',
    belowListPresentsAtMax30NearestTerms: 'The list below shows a maximum of 30 upcoming dates.',
    cancelledReservationTitle: 'An edited reservation has the status of a cancelled reservation. Do you want to change the status of this reservation while saving?',
    cancelledReservationOkBtn: 'Save and restore',
    cancelledReservationCancelBtn: 'Save as cancelled',
    cannotConvertSimpleReservationToCyclicService: 'In edit mode you cannot select cyclic services',
    cannotEditPriceDesc: 'If you selected edit of the current and future reservations, price change is not possible.',
    cannotEditPriceTitle: 'Price cannot be changed',
    checkProfile: 'Check the profile',
    customerInvoiceDataLoadError: 'Unable to load customer invoice data',
    customerInvoiceDataNotFound: 'This customer has not provided invoice data yet',
    cyclicReservation: 'Cyclic till cancellation',
    day: 'Day',
    didYouMean: 'Did you mean:',
    discountCode: 'Discount code',
    discountApplied: 'Discount code applied',
    discountAndPassApplied: 'Discount code and pass applied',
    doYouWantToChangeReservationStatus: 'Do you want to change your reservation status?',
    duration: 'Duration:',
    durationMustBeBiggerThanZero: 'The duration of the service must be greater than zero',
    hasPaidParams: 'some options are additionally paid',
    editCyclicReservationTitle: 'Editing a periodical reservation',
    editCyclicReservationDesc: 'The selected reservation is periodical. Do you want to edit all future bookings or just the current one?',
    editCyclicReservationBtnCancel: 'Edit only the current one',
    editCyclicReservationBtnOk: 'Edit all future',
    editReservation: 'Editing a reservation',
    editedPriceIsForSingleReservation: 'Below price is for the currently edited reservation',
    editedPriceIsForSingleReservationAndFutureOnes: 'Below price is for the current and future reservations',
    editedPriceIsForWholeCycle: 'Below price is for the whole cycle of reservations',
    email: 'E-mail',
    emailIsInvalid: 'The e-mail address provided is invalid',
    emailIsRequired: 'E-mail address is required',
    emptyDurationDesc: 'Due to the impact of parameters on the duration, it has been reset. Please verify the service duration.',
    emptyDurationTitle: 'Duration has been reset',
    errorChangedPriceTitle: 'You cannot save changes',
    errorChangedPriceDesc: 'Introduced changes affects price of this reservation. You have no sufficient permissions to save them. Please contact with Bookero account owner.',
    estimatedTimeForTheSelectedServiceIs: 'The estimated time for the selected service is:',
    fillCustomerInvoiceData: 'Fill in customer data',
    fourWeeks: 'Four weeks',
    futurePaymentsHaveAnnotations: 'Some future reservations have different payment configuration. It\'s payment configurations won\'t be overriden until you select option to override all future payments.',
    givenPriceCanBeDifferentAccordingToPriceRules: 'The price quoted for the service may vary depending on the price rules defined.',
    iReadAndAccept: 'I have read and accept',
    invoiceAddress: 'Address',
    invoiceCity: 'City',
    invoiceCompanyTitle: 'Name on invoice',
    invoiceCountry: 'Country',
    invoiceDataTitle: 'Data for invoice',
    invoiceEditDisabled: 'Changing the invoice settings is only possible during editing without modifying future reservations',
    invoiceIsCompany: 'Invoice for company',
    invoiceNip: 'Tax ID',
    invoicePostCode: 'Postal code',
    issueInvoice: 'Issue an invoice?',
    loadingTerms: 'Loading data...',
    nameAndSurname: 'Name and surname',
    nameIsRequired: 'First and last name is required',
    nearestPossibleTerms: 'Nearest possible dates',
    noFreeTermsForSelectedService: 'No free dates for the selected service',
    newPeriodicityDates: '{count} new reservations will get "New" payment status | {count} new reservation will get "New" payment status | {count} new reservations will get "New" payment status',
    nonStandardTerm: 'Customized date',
    notAvailableTermsDetectedDescAdd: 'adding',
    notAvailableTermsDetectedDescEdit: 'edition',
    notAvailableTermsDetectedTitle: 'Unavailable dates were detected',
    notAvailableTermsDetectedDesc: 'At least one of the selected dates is not available. Do you still want to continue {descPhrase} this reservation?',
    notAvailableTermsDetectedBtn: 'anyway',
    notifyClient: 'Notify the customer',
    okChangePrice: 'Change price',
    oneTime: 'once',
    or: 'or',
    orEnterPassCode: 'Pass code',
    originalPriceIs: 'Price from pricing:',
    originalPriceIsWithPass: 'Price from pricing (with pass):',
    originalPriceIsWithDiscountAndPass: 'Price from pricing after discount (with pass):',
    originalPriceIsWithDiscount: 'Price from pricing after discount:',
    packageReservation: 'Reservation package',
    paid: 'Paid',
    paymentMethod: 'Payment method',
    passSettings: 'Pass usage',
    paymentStatusAdvanced: 'Partially paid',
    paymentStatusNew: 'New',
    paymentStatusPending: 'During the settlement',
    paymentStatusCanceled: 'Cancelled',
    paymentStatusCompleted: 'Completed',
    periodicityDaysPaymentReminder: 'How many days before the reservation is the payment link sent',
    periodicityHoursPaymentCancel: 'How many hours before the reservation is it canceled in case of lack of payment',
    periodicityFirstPayment: 'Is payment for the first reservation required at the time of booking',
    periodicityType: 'Type of periodicity:',
    periodicityTerminsSettings: 'When I change the date of a cyclic reservation:',
    periodicityTerminsSettingsDates: 'Change the dates of subsequent reservations according to the selected periodicity',
    periodicityTerminsSettingsHours: 'Change the hours of subsequent reservations according to the selected time',
    periodicitySettings: 'Periodicity settings',
    personalDataProcessing: 'Processing of personal data',
    personalDataProcessingDesc: 'Consents should be expressed by the customer',
    phone: 'Mobile phone',
    phoneIsInvalid: 'The phone number is invalid',
    phoneIsRequired: 'Valid phone number is required',
    previouslySelectedHourIsUnavailable: 'The selected hour is not available. Choose another hour:',
    previouslySelectedHourIsUnavailableIn30Dates: 'The selected hour is not available amongst nearest 30 dates. Choose another hour:',
    previouslySelectedTermIsUnavailable: 'The selected date is not available. Choose another date:',
    priceForAllReservations: 'for the whole cycle',
    priceForSingleReservation: 'for single reservation',
    priceWillBeChangedForFutureInquiriesTitle: 'Warning!',
    priceWillBeChangedForFutureInquiriesDesc: 'You have changed price, which will be applied to future inquires too (excluding reservations with modified payment settings). Do you want to continue?',
    priceWillBeChangedForFutureInquiriesAltDesc: 'You have changed price, which will be applied to future inquires too. Do you want to continue?',
    priceWillBeChangedForAllFutureInquiriesDesc: 'You have changed price, which will be applied to all future inquires too. Do you want to continue?',
    priceWillBeChangedForTheWholeCycleTitle: 'Warning!',
    priceWillBeChangedForTheWholeCycleDesc: 'Price will be changed for the all reservations in the cycle',
    privacyPolicy: 'privacy policy',
    provideDiscountCode: 'Provide discount code',
    passesCannotBeUsedWithDiscounts: 'A discount code was used - cannot be combined with passes',
    provideProperChildrenNumber: 'Enter the correct number of children',
    provideProperDaysNumber: 'Enter the correct number of days',
    provideProperPeopleNumber: 'Enter the correct number of people',
    provideYourOwnPrice: 'Provide your own price',
    provideYourOwnPriceForReservation: 'Provide your own price for reservation',
    provideYourOwnPriceForPackage: 'Provide your own price for reservations package',
    rejectedReservationTitle: 'An edited reservation has the status of a rejected reservation. Do you want to change the status of this reservation while saving?',
    rejectedReservationOkBtn: 'Save and accept',
    rejectedReservationCancelBtn: 'Save as rejected',
    repeatEvery: 'Repeat every',
    reservationType: 'Reservation type',
    required: '(required)',
    search: 'Search',
    searchSinceDay: 'Search from day:',
    select: 'Choose',
    selectDate: 'Choose a date',
    selectMonth: 'Choose a month',
    selectHour: 'Select the time',
    selectPaymentMethod: 'Choose a method',
    selectCustomerToSeeAvailablePasses: 'Select a customer to see available passes',
    selectedParamsWillChangeDuratioBy: 'Warning! The selected parameter values affecting the service duration will change it by ',
    selectPass: 'Select pass',
    selectPaymentStatus: 'Select status',
    selectPeriodicityType: 'Select the type of periodicity',
    selectTerm: 'Choose a date',
    selectWorker: 'Select employee',
    showTerms: 'Show the dates',
    skipAdvance: 'skip advance',
    checkPass: 'Check pass code',
    customerHasNoPasses: 'Customer has no passes',
    passApplied: 'Pass applied',
    passCannotBeAppliedToPackagePayment: 'Passes cannot be used when paying for a package of reservations',
    passCode: 'Pass to use',
    passCodeCheckErrorTitle: 'Pass requires verification',
    passCodeCheckErrorDesc: 'Before saving, you must verify the correctness of the pass code',
    passCodeIsInvalid: 'Invalid pass code',
    passCodeIsValid: 'Valid pass code',
    passCodeNotVerified: 'Verify the pass code before saving the reservation',
    passCodeErrorTitle: 'A problem with the pass was detected',
    passCodeErrorDesc: 'The given pass does not work for the selected configuration - e.g. it does not cover the selected service or the reservation date is outside the pass validity period. Change the pass to another one or resign from using the pass to save the reservation.',
    passCodeRemovedTitle: 'Pass removed from reservation',
    passCodeRemovedDesc: 'Pass has been removed from this reservation - please verify price of reservation or select a customer which has passes for use.',
    youMustToSelectPeriodicityType: 'Choose the type of periodicity',
    serviceIsRequired: 'Selection of the service is required',
    singleReservation: 'Single reservation',
    thisFieldIsRequired: 'This field is required',
    thisTermIsUnavailable: 'This term is unavailable',
    times: 'times',
    toPay: 'To pay: ',
    toPayWithAdvance: 'Total: ',
    tos: 'terms of service',
    toSelectTermSelectService: 'To be able to select a date, you must first select a service.',
    toSelectTermSelectPeriodicityType: 'To be able to select an appointment, you must first select the type of periodicity.',
    toSelectTermSelectDate: 'To be able to select an appointment, you must first select the date. Click the "Select date" button.',
    toSelectTermSelectHour: 'To be able to select a date, you must first select the time. Click the "Select time" button.',
    twoWeeks: 'Two weeks',
    typeOfPeriodicityCanBeEditedOnlyInTheFirstReservationOfTheCycle: 'The type of periodicity can not be edited in the cyclic reservations',
    untilCancel: 'until cancel',
    untilCancelInfo: 'This cycle exists till cancel - below the nearest reservations are displayed',
    untilCancelNote: 'System creates at most 30 reservations forward. Please remember to set the "Allow maximum reservations" parameter in system options to avoid situation when somebody can reserve dates which will be used to extend cyclic reservations.',
    untilCancelShortNote: 'System creates at most 30 reservations forward.',
    updateAllFuturePayments: 'Override all future payments',
    useAdvance: 'apply advance',
    useAvailableTerm: 'Use the time available',
    usePricingPrice: 'use it',
    waitingListReservationTitle: 'An edited reservation is on the waiting list. Do you want to change the status of this reservation while saving?',
    waitingListReservationOkBtn: 'Save and accept',
    waitingListReservationCancelBtn: 'Save and left on the waiting list',
    warning: 'Attention!',
    week: 'Week',
    workerForTheServiceWithTermsIsRequired: 'Selecting an employee for a service with dates is required',
    youCanEditServiceOnlyInTheFirstReservationOfTheCycle: 'The service can not be edited in the cyclic reservations',
    youEditCancelledReservation: 'Edited is a cancelled reservation. While saving this form you will be able to change its status.',
    youEditRejectedReservation: 'Edited is a rejected reservation. While saving this form you will be able to change its status.',
    youEditReservationWhichWaitsForAccpet: 'Edited is a reservation pending acceptance. While saving this form you will be able to change its status.',
    youEditWaitingListReservation: 'Edited is a reservation from waiting list. While saving this form you will be able to change its status.',
    youMustselectTerm: 'You must choose a date for the reservation'
  },
  reservationFormCustomHour: {
    selectedHour: ' at ',
    selectedTerm: 'Selected date:',
    selectTerm: 'Choose a date:',
    selectTermHour: 'Choose an hour:',
    setTerm: 'Set a date',
    warning: '<strong>Attention!</strong> When defining a customized reservation date, the reservation rule, availability and opening rule are not included.',
    youHaveToSelectDate: 'You must select a date'
  },
  reservationFormParams: {
    givenPriceForAdditionalFeatures: 'The price quoted for additional features may vary depending on the defined price rules.',
    information: 'Information:',
    parameterIsRequired: 'Parameter required',
    selectValue: 'Choose a value',
    thisParameterIsRequired: 'This parameter is required'
  },
  reservationFormTimePopup: {
    select: 'Choose',
    selectHour: 'Select the time:'
  },
  reservationParameters: {
    addNewParameter: 'Add a new parameter',
    emptyState: 'No reservation parameters defined...',
    loadingState: 'Loading data...',
    name: 'Parameter name',
    parametersOrderingChanged: 'The order of booking parameters has been saved',
    service: 'The service',
    required: 'Required',
    title: 'Reservation parameters',
    type: 'Type of parameter'
  },
  reservationParametersForm: {
    addTitle: 'Add the reservation parameter',
    additionalPrice: 'Additional price:',
    additionalDuration: 'Additional duration (in min):',
    addParamValue: 'Add the value of the parameter',
    affectsDuration: 'It affects the duration:',
    affectsPrice: 'It affects the price:',
    checkbox: 'Checkbox (multiselect)',
    dropdown: 'Select field for selection',
    editTitle: 'Editing the reservation parameter',
    fieldMustBeNumber: 'Field value must be a number',
    fieldMustBeNumberDividedBy5AndBetween1440: 'Field value must be a number divisible by 5 and smaller than 1440',
    firstSelected: 'Select by default first value',
    infoText: 'Text to be displayed',
    inputText: 'Text box for entry',
    paramAdded: 'The booking parameter has been added',
    paramConfigurationChanged: 'The configuration of the booking parameter has been changed',
    paramName: 'Name of the parameter:',
    paramContent: 'Content of the parameter:',
    paramSettings: 'Parameter settings',
    paramValues: 'The values of the parameter',
    paramValueName: 'Name of value:',
    paramType: 'Type of parameter:',
    published: 'Published:',
    publishedOnlyInPanel: 'Published only in the panel:',
    removeParamValue: 'Delete parameter value',
    required: 'Required:',
    servicesTitle: 'Limit parameter to the selected services',
    servicesDesc: 'If no service selected, the parameter will work for the all services',
    textarea: 'Large text field',
    valueAdditionalDuration: 'Additional duration (in min)',
    valueAdditionalPrice: 'Additional price',
    valueName: 'Name of values',
    youSeeSpecialParamSettings: 'You are viewing the special parameter settings.',
    willBeHiddenForDays: 'If this option is enabled, this parameter won\'t be visible for daily services'
  },
  reservationParametersListItem: {
    affectsDuration: 'This parameter can affect service duration',
    affectsPrice: 'This parameter can affect service price',
    allServices: 'All',
    checkboxField: 'Checkbox (multiselect)',
    editParameter: 'Edit parameter',
    hide: 'Hide',
    hideParameter: 'Hide the parameter',
    infotextField: 'Text to be displayed',
    no: 'No',
    parameterName: 'Name of the parameter:',
    parameterType: 'Type of parameter:',
    publish: 'Publish',
    publishParameter: 'Publish the parameter',
    removeParameter: 'Delete parameter',
    removeParamTitle: 'Deleting a reservation parameter',
    removeParamDesc: 'Are you sure you want to delete the selected reservation parameter?',
    removeParamBtn: 'Delete a parameter',
    required: 'Required:',
    selectField: 'Select field for selection',
    selectedParameterHasBeenRemoved: 'The selected reservation parameter has been deleted',
    selectedParameterHasBeenPublished: 'The selected parameter has been published',
    selectedParameterHasBeenUnpublished: 'The selected parameter has been published',
    services: 'Services:',
    textareaField: 'Large text field',
    textField: 'Text box',
    thisParameterIsNotPublished: 'This parameter is not published',
    thisParameterIsVisibleOnlyInAdminPanel: 'This parameter is only visible in the admin panel',
    yes: 'Yes'
  },
  reservationRules: {
    activeRules: 'Active rules',
    addNewRule: 'Add a new rule',
    allowMeToAcceptManually: 'let me accept reservations manually',
    automaticallyAccept: 'automatically accept the resrvations',
    ifFreeTermsAreAvailableReservationsWillBeAcceptedAutomatically: 'In case of free dates, reservations will be accepted automatically from now on.',
    ifFreeTermsAreAvailableReservationsWillBeAcceptedManually: 'In case of free dates, reservations will be accepted manually from now on.',
    ifReservationIsNotRejectedByRules: 'If a reservation is not covered by the rejection rule',
    ifTermIsFree: 'If the date is free:',
    noReservationRules: 'No reservation rules were found...',
    ruleDescription: 'Description of how a rule works',
    ruleParams: 'Rule parameters',
    ruleWorkingMethod: 'How the rules work',
    title: 'Reservation rules'
  },
  reservationRulesForm: {
    addTitle: 'Adding a reservation rule',
    allPersons: 'all people (with added reservation)',
    applyToService: 'Apply to the service:',
    biggerThan: 'greater than',
    configurationTitle: 'Reservation rule configuration',
    editTitle: 'Editing the reservation rule',
    numberOfConfirmedReservationsBiggerThan: 'Number of confirmed reservations greater than:',
    numberOfPeopleCountedAs: 'Number of people counted as:',
    numberOfPeoplePerOneTerm: 'Number of people per date',
    numberOfReservationsPerOneTerm: 'Number of reservations per date',
    rejectReservationWhen: 'Reject the reservation when:',
    reservationRuleAdded: 'The reservation rule has been added',
    reservationRuleDataChanged: 'The reservation rules concerned have been changed',
    singleReservation: 'a single existing reservation',
    smallerThan: 'less than'
  },
  reservationRulesListItem: {
    action: 'Action:',
    biggerThan: ' greater than ',
    countOfConfirmedReservations: 'Number of confirmed reservations: ',
    defaultRuleDescription: '<p><strong>The employee:</strong> no free employees</p><p><strong>Action:</strong> Reject reservation</p>',
    editRule: 'Edit the rule',
    everyWorkerHasAReservationLimit: 'Each employee has a limit on the number of bookings for <strong>one date</strong>, which can be changed in the employee profile settings. The default limit is a maximum <strong>1 reservation</strong> for one date.',
    lesserThan: ' less than ',
    oneTermMaxAmountOfReservations: 'For one date you accept a maximum ',
    oneTermOneReservation: 'For one date you accept a maximum of <strong> one reservation</strong>',
    rejectReservation: 'Reject reservation',
    removeReservationRuleTitle: 'Deleting a reservation rule',
    removeReservationRuleDesc: 'Are you sure you want to delete a selected reservation rule?',
    removeReservationRuleBtn: 'Delete the rule',
    removedReservationRule: 'The selected rule has been deleted',
    removeRule: 'Delete the rule',
    reservationWillBeRejectedIf1: 'A reservation will be rejected if, for the selected date, the sum of the number of confirmed reservations and the number of people indicated in the form is ',
    reservationWillBeRejectedIf2: 'A reservation will be rejected if you have at least one confirmed single reservation for the selected date for the number of people ',
    ruleDescriptionAllPeopleCount: '<p><strong>People number (all people): </strong>',
    ruleDescriptionPeopleCountSingleReservation: '<p><strong>Number of people (single existing reservation): </strong>'
  },
  reservationRulesProblemPopup: {
    noFreeWorkersTitle: 'No free employees',
    noFreeWorkersDesc: '<p>There are no free employees at this time.</p>',
    noFreeWorkersOkButton: 'Edit the reservation',
    noFreeWorkersCancelButton: 'Reject the reservation',
    reservationNotMeetRulesTitle: 'Reservation does not meet the rules',
    reservationNotMeetRulesDesc: '<p>The reservation does not meet the following reservation rules',
    reservationNotMeetRulesOkButton: 'Edit your reservation',
    reservationNotMeetRulesCancelButton: 'Reject the reservation',
    selectedWorkerIsUnavailableTitle: 'The selected employee is not available',
    selectedWorkerIsUnavailableDesc: '<p>The selected employee is not available at this time. Select another employee from the list below:</p>',
    selectedWorkerIsUnavailableOkButton: 'Change the employee and accept',
    selectedWorkerIsUnavailableCancelButton: 'Reject the reservation',
    selectWorker: 'Select an employee'
  },
  reservationStatus: {
    cancelled: 'Cancelled',
    clientNotPresent: 'Customer not present',
    confirmed: 'Confirmed',
    newRequest: 'New request',
    rejected: 'Rejected',
    waitingList: 'Waiting list'
  },
  reservationStatusChange: {
    cancelReservationTitle: 'Cancellation of reservation',
    cancelCyclicReservation: 'The selected reservation is periodical. Cancel only this reservation, or cancel it together with all future periodical reservation?',
    cancelAll: 'Cancel all',
    cancelOnlyThisOne: 'Just cancel this reservation',
    cancelReservation: 'Cancel the reservation',
    checkDuplicatedReservation: 'Similar reservation is: <a href="{url}">#{id}</a>',
    dateUnblocked: 'Selected date has been unblocked',
    doYouWantCancelReservation: 'Do you want to cancel this reservation?',
    doYouWantToRejectRequest: 'Do you want to reject this date request?',
    notifyAboutFreeTerm: 'Do you want to notify the following people about an available date?',
    okContinue: 'Yes, save',
    rejectReservationTitle: 'Rejecting a reservation',
    rejectCyclicReservation: 'The selected reservation is periodical. Should I reject this reservation only, or should I reject it together with all future reservations from the cycle?',
    rejectAll: 'Reject all',
    rejectOnlyThisOne: 'Reject only this reservation',
    rejectRequest: 'Reject the inquiry',
    rejectRequestTitle: 'Rejection of the inquiry',
    reservationAccepted: 'The reservation has been accepted',
    reservationCancelled: 'The reservation was cancelled',
    reservationCancelledNotificationsSent: 'The reservation was cancelled, notifications were sent',
    reservationRejected: 'The reservation was rejected',
    reservationRejectedNotificationsSent: 'Reservation was rejected, notifications were sent',
    requestRejectedWithWaitingListTitle: 'Rejection of the inquiry',
    requestRejectedWithWaitingListDesc: 'Do you want to reject the inquiry or add it to the waiting list?',
    requestRejectedWithWaitingListCancelButton: 'Reject the inquiry',
    requestRejectedWithWaitingListOkButton: 'Add to the waiting list',
    requestRejectedDesc: 'Do you want to reject this date request?',
    requestRejectedTitle: 'Rejection of the inquiry',
    unblockDate: 'Unblock date',
    unblockDateTitle: 'Unblock date',
    unblockDateDesc: 'The selected blocked date is periodical. Unlock only this date, or unblock it together with all future blocked dates?',
    unblockDateCancelBtn: 'Unblock all',
    unblockDateOkBtn: 'Unblock only this one',
    unblockDate2Title: 'Unblock date',
    unblockDate2Desc: 'Do you want to unblock this date?',
    unblockDate2Btn: 'Unblock date',
    yesNotify: 'Yes, notify!',
    youHaveWaitingList: 'You have a waiting list for the date you choose'
  },
  searchDateForm: {
    addReservation: 'Reservation',
    anyWorker: 'Any employee',
    blockDate: 'Block',
    blockReservationDate: 'Block date',
    checkTerm: 'Find free date',
    cyclicReservation: 'Cyclic till cancellation',
    cyclicType: 'Type of periodicity:',
    duration: 'Duration:',
    durationMustBeBiggerThanZero: 'The duration of the service must be greater than zero',
    estimatedTimeForService: 'The estimated time for the selected service is:',
    foundedFreeWorkers1: 'Founded one available worker:',
    foundedFreeWorkersN: 'Founded {count} available workers:',
    loadingTerms: 'Loading data...',
    nearestPossibleTerms: 'The closest possible dates',
    noFreeTermsForSelectedService: 'No free time limits for the selected service',
    oneTime: 'once time',
    or: 'or',
    packageReservation: 'Reservation package',
    provideCorrectPeopleNumber: 'Enter the correct number of people',
    provideProperChildrenNumber: 'Enter the correct number of children',
    provideProperDaysNumber: 'Enter the correct number of days',
    repeatEvery: 'Repeat every:',
    repeatEveryDay: 'Day',
    repeatEveryWeek: 'Week',
    repeatEveryTwoWeeks: 'Two weeks',
    repeatEveryFourWeeks: 'Four weeks',
    reservationType: 'Type of reservation:',
    searchSinceDay: 'Search from day:',
    select: 'Choose',
    selectCyclicType: 'Select the type of periodicity',
    selectDate: 'Choose a date',
    selectHour: 'Select the time',
    selectMonth: 'Select the month',
    selectTerm: 'Choose a date',
    selectWorker: 'Select an employee:',
    serviceIsRequired: 'Selection of the service is required',
    showTerms: 'Show the dates',
    singleReservation: 'Single reservation',
    times: 'times',
    thisListShowsAtMax30Results: 'The list below shows a maximum of 30 upcoming dates.',
    toSelectTermSelectCyclicType: 'To be able to choose an appointment, you must first select the type of periodicity.',
    toSelectTermSelectDate: 'To be able to select an appointment, you must first select the date. Click the "Select date" button.',
    toSelectTermSelectHour: 'To be able to select an appointment, you must first select the time. Click the "Select Time" button.',
    toSelectTermSelectService: 'To be able to select a date, you must first select the service.',
    warning: 'Attention!',
    youMustSelectCyclicType: 'Please select the type of periodicity',
    youMustSelectTermForReservation: 'You must choose a date for the reservation',
    youMustSelectWorkerForServiceWithTerms: 'Selecting an employee for a service with dates is required'
  },
  searchPopup: {
    insertNamePhoneOrEmail: 'Enter your name, surname, phone or e-mail address:',
    loadingResults: 'Loading results...',
    noResultsForGivenPhrase: 'No reservations were found that match the phrase...',
    title: 'Look for reservations'
  },
  searchPopupReservation: {
    cancelReservation: 'Cancel the reservation',
    cancelReservationTitle: 'Cancellation of reservation',
    cancelReservationDesc: 'The selected reservation is periodical. Cancel only this reservation, or cancel it together with all future periodical reservations?',
    cancelReservationDesc2: 'Do you want to cancel this reservation?',
    cancelReservationCancelButton: 'Cancel all',
    cancelReservationOkButton: 'Just cancel this reservation',
    cancelReservationOkButton2: 'Cancel the reservation',
    cardRegistered: 'Registered card',
    clientNotPresent: 'The client didn\'t show up',
    clientNotPresentTitle: 'The client didn\'t come?',
    clientNotPresentDesc: 'If the customer did not show up, click Yes to write it down in his statistics.',
    clientNotPresentOkButton: 'Yes, the customer didn\'t show up',
    clientSavedAsNotPresent: 'The absence of the client was saved',
    category: 'Category: ',
    emailPrefix: 'email: ',
    paid: 'Paid',
    phonePrefix: 'tel: ',
    readMoreAboutReservation: 'Find out more about the reservation',
    reservationCancelled: 'The reservation was cancelled',
    reservationCancelledNotificationsSent: 'The reservation was cancelled, notifications were sent',
    unpaid: 'Unpaid',
    youHaveWaitingListTitle: 'You have a waiting list for the selected date',
    youHaveWaitingListDesc: 'Should I notify the following people about the free time?<br>',
    youHaveWaitingListOkButton: 'Yes, notify!'
  },
  services: {
    addCategory: 'Add a category',
    addNewCategory: 'Add a new category',
    addNewService: 'Add a new service',
    categoryAdded: 'The category has been added',
    categoryChanged: 'The category has been changed',
    categories: 'Categories',
    categoryID0: 'Category ID: 0',
    categoryID: 'Category ID: ',
    categoryOrderingSaved: 'The order of service categories has been saved',
    categoryRemoved: 'The category has been deleted',
    duration: 'Duration',
    editCategory: 'Edit category',
    editCategoryName: 'Edit category name',
    emptyState: 'No services in this category',
    listOfAvailableServices: 'List of available services',
    name: 'Service name',
    payments: 'Payments',
    removeCategory: 'Delete the category',
    removingCategoryTitle: 'Deletion of category',
    removingCategoryDesc: 'Are you sure you want to delete the selected category? Services from this category will be assigned to a group of services without a category.',
    removingCategoryBtn: 'Delete a category',
    servicesOrderingSaved: 'The order of services has been saved',
    serviceType: 'Type of service',
    title: 'Services'
  },
  serviceCategoryPrompt: {
    andAllLanguageVersions: ' and all language versions for this category',
    setCategoryName: 'Enter a category name'
  },
  serviceListItem: {
    constantService: 'Permanent service',
    customerDecide: 'Customer choice',
    daysService: 'Daily reservations',
    duration: 'Duration:',
    editService: 'Edit service',
    hide: 'Hide',
    hideService: 'Hide the service',
    minutes: ' min',
    no: 'No',
    notRelated: 'NR',
    payments: 'Payments:',
    periodicalService: 'Periodic service',
    publish: 'Publish',
    publishService: 'Publish the service',
    removingServiceTitle: 'Removal of service',
    removingServiceDesc: 'Are you sure you want to delete the selected service?',
    removingServiceBtn: 'Delete the service',
    removeService: 'Delete the service',
    selectedServiceCopied: 'The selected service has been copied',
    selectedServicePublished: 'The selected service has been published',
    selectedServiceRemoved: 'The selected service has been deleted',
    selectedServiceUnpublished: 'The selected service has been unpublished',
    serviceType: 'Type of service:',
    termService: 'Term service',
    thisServiceIsHidden: 'This service is hidden',
    thisServiceIsTrashed: 'This service is trashed',
    tooltipNoWorkersForService: 'No staff assigned to the service\nService ID: {serviceID}',
    tooltipService: 'Service ID: {serviceID}',
    yes: 'Yes',
    withAdvancePayment: 'with advance'
  },
  servicesForm: {
    accordingToDurationTimes: '(by duration)',
    addCycle: 'Add package',
    addDuration: 'Add the duration',
    addTerm: 'Add the term',
    advancePayment: 'Enable advance payments',
    advancePaymentType: 'Advance payment type',
    advancePaymentTypePercentage: 'Percentage advance payment',
    advancePaymentTypeQuote: 'Fixed-amount advance payment',
    advancePaymentValue: 'Advance payment value',
    allowDurationSelection: 'Let me choose the duration:',
    availabilityDuringTheWeek: 'Service availability during the week',
    category: 'Category:',
    childrenPrice: 'Additional price for children:',
    color: 'Colour:',
    constantService: 'Permanent service',
    createQRTicketsForReservations: 'Create QR tickets for booking:',
    dailyEndAvailable: 'Select type of daily reservations',
    dailyEndAvailableDays: 'Full-day reservations',
    dailyEndAvailableNights: 'Reservations for a night',
    dailyEndAvailableDescription: 'When day bookings are selected, it means that the resource is released during the day after the last night. Example: if a rental day ends at 12AM and the next rental day starts the same day (e.g. at 3PM) we suggest enabling this option for the service.',
    day: 'Day',
    daysService: 'Daily reservations',
    duration: 'Duration:',
    durationTimes: 'Times of duration',
    durationsListName: 'Name',
    durationsListTime: 'Duration (min.)',
    durationsListPrice: 'Price',
    emailNotification: 'E-mail notification additional text:',
    emptyState: 'No dates for this service',
    emptyStateForDurations: 'No duration for this service',
    emptyStateForPeriodicity: 'No reservation packages for this service',
    fourWeeks: 'Four weeks',
    forAll: 'for the whole',
    forReservation: 'for reservation',
    getResponseTitle: 'Integration with GetResponse',
    googleMeet: 'Create Google Meet while adding a reservation',
    hideService: 'Hide the service:',
    hiddenServicesAreVisibleOnlyInAdminPanel: 'Hidden services are visible only in the administration panel',
    ifThisOptionIsEnabledTheDropdownAppear: 'By enabling this option, the number of people on the form will appear as a selection list with the possibility of specifying a value between the maximum and minimum number of people',
    invalidAdditionalPrice: 'Invalid amount',
    invalidAdvancePaymentValuePercentage: 'Invalid amount (percentage advance payment must be between 0–100)',
    invalidAdvancePaymentValueQuote: 'Invalid amount',
    invalidChildrenPrice: 'Invalid amount',
    invoicesTitle: 'Settings for the invoice (Fakturownia)',
    limitNumberOfPeoplePerOneReservation: 'Limit number of people per booking',
    maximumPeopleNumberMustBeBiggerEqualToMinimalPeopleNumber: 'The maximum number of people must be greater than or equal to the minimum number of people',
    maximalPeopleNumber: 'Maximum number of people:',
    minimalPeopleNumber: 'Minimum number of people:',
    name: 'Name:',
    offsetsAsServiceDurationTime: 'Intervals such as the duration of the service',
    offsetsDuringHourSelection: 'Intervals when selecting the time of reservation:',
    outlookMeet: 'Create Outlook meeting while adding a reservation',
    paymentMethodsForTheService: 'Payment methods for the service',
    passesAreDisabledForPackagePayment: 'Passes are not available for package payment',
    periodicity: 'Reservation packages:',
    periodicityListName: 'Name',
    periodicityListPrice: 'Price',
    periodicityRepeat: 'Repeat every',
    periodicalService: 'Periodic service (defines hours of availability)',
    periodicityPaymentType: 'Type of periodical payments',
    periodicityPaymentTypePackage: 'Payment for package',
    periodicityPaymentTypeSingle: 'Payment for single reservation',
    periodicityDaysPaymentReminder: 'Send payment link X days before reservation',
    periodicityDaysPaymentReminderNote: 'If number of days is equal to 0, payment links won\'t be send',

    periodicityDaysPaymentReminderFor: 'Payment in advance for reservations',
    periodicityDaysPaymentReminderForNote1: 'Payment link will be for the nearest reservations',
    periodicityDaysPaymentReminderForNote2: 'Payment link will be connected with reservations in the month',
    periodicityDaysPaymentReminderForNote3: 'Please provide number of reservations for use in payment link. For example "2" will mean that payment link will be for next 2 reservations.',
    periodicityDaysPaymentReminderForTypes: {
      lack: 'For nearest',
      fullMonth: 'For full month',
      custom: 'Custom value'
    },
    periodicityHoursPaymentCancel: 'Cancel reservations X hours before reservation if no payment',
    periodicityHoursPaymentCancelNote: 'If number of hours is equal to 0, reservations won\'t be cancelled',
    periodicityFirstPayment: 'Require payments for the first reservation in the moment of reservation',
    periodicityFirstPaymentCancelNote: '<strong>Attention!</strong> First payment must be done in the timeframe compatible with configuration of the used payment method. <br>Lack of payment will cancel the whole cycle.',
    removeCycle: 'Delete package',
    removeDuration: 'Remove the duration',
    removeTerm: 'Delete the term',
    requiresChildrenNumber: 'Additional number of children:',
    requiresFiveMultiplication: 'Multiples of 5 minutes are required',
    requiresPayment: 'Requires payment:',
    requiresPeopleNumber: 'Requires the number of people',
    serviceChanged: 'The service data has been changed',
    serviceData: 'Service data',
    serviceHasBeenAdded: 'The service has been added',
    servicePrice: 'Service price:',
    serviceTermsList: 'List of service terms',
    serviceType: 'Type of service:',
    termService: 'Term service (event)',
    termsListName: 'Name',
    termsListDate: 'Date',
    termsListHour: 'Time',
    thisServiceWillSupportDays: 'This service is daily',
    thisServiceWillSupportHours: 'This service is hourly',
    titleAdd: 'Adding a service',
    titleEdit: 'Edition of the service',
    twoWeeks: 'Two weeks',
    qrTicketAdditionalInformation: 'Additional information on the ticket:',
    youMustToSpecifyAtLeastOneTermForThisService: 'You must specify at least one date for this service',
    youMustToSpecifyHourForallCreatedTerms: 'The time should be specified for all the dates created for this service',
    youMustSpecifyAtLeastOneDurationTime: 'You must define at least one duration',
    youMustDefineAtLeastOneCycle: 'You must define at least one cycle',
    youMustSpecifiyValidNumberOfDays: 'You must to specify a proper number of days',
    youMustSpecifiyValidNumberOfHours: 'You must to specify a proper number of hours',
    youMustSpecifiyValidNumberOfReservations: 'You must to specify a proper number of reservations (range: 1-30)',
    week: 'Week',
    withoutCategory: 'No category',
    workersDoingService: 'Service employees'
  },
  settings: {
    main: {
      additionalFunctions: 'Additional system functions',
      adjustFunction: 'Configure',
      availableIntegrations: 'Available integrations',
      basicFunctions: 'Basic system functions',
      buyHigherPackage: 'Buy a higher package',
      dailyReservationsTitle: 'Daily reservations',
      dailyReservationsDesc: 'Allows daily reservations',
      emails: 'E-mail notifications',
      gdpr: 'GDPR',
      myPageTitle: 'My website',
      myPageDesc: 'It gives you the opportunity to create your own website',
      servicesTitle: 'Services',
      servicesDesc: 'Specification of specific services for a particular reservation',
      reservationParamsTitle: 'Reservation parameters',
      reservationParamsDesc: 'Adjusting additional parameters in bookings',
      smsTitle: 'SMS notifications',
      smsDesc: 'Sending SMS notifications regarding reservations',
      paymentsTitle: 'Payment for reservation',
      paymentsDesc: 'Charging a reservation fee',
      workersTitle: 'Employees',
      workersDesc: 'Assigning specific employees to services and reservations',
      googleCalendarTitle: 'Integration with Google Calendar',
      googleCalendarDesc: 'Preview your reservation directly in your Google calendar. <strong>Attention!</strong> This option cannot be enabled with the integration with the Outlook calendar.',
      outlookCalendarTitle: 'Integration with the Outlook calendar',
      outlookCalendarDesc: 'View your reservation directly in your Outlook calendar. <strong>Attention!</strong> This option cannot be enabled with the Google Calendar integration.',
      getResponseTitle: 'Integration with GetResponse',
      getResponseDesc: 'The ability to connect services with lists in GetResponse.',
      fakturowniaTitle: 'Integration with the Fakturownia',
      fakturowniaDesc: 'The ability to issue and download invoices from the Bookero panel.',
      multilanguageTitle: 'Multilanguage',
      multilanguageDesc: 'Additional languages can be set in the booking form and the website',
      plugin: 'Plugin',
      reservations: 'Reservations',
      settingsSaved: 'Settings have been saved',
      thisFunctionHasRequirements: 'This function requires services enabled',
      thisFunctionHasRequirementPayment: 'This function requires payments enabled',
      title: 'Settings'
    },
    multilanguage: {
      additionalLanguages: 'Select additional languages you wish to use',
      language: 'Language',
      settingsSaved: 'Multilanguage settings have been changed',
      title: 'Multilanguage settings'
    }
  },
  settingsBasicBlock: {
    changeSettings: 'Change settings'
  },
  settingsEmails: {
    actionButtonBgColor: 'Action button background colour:',
    actionButtonFontColor: 'Action button font colour:',
    address: 'The address:',
    addressButtonBgColor: 'The background colour of the address button:',
    addressButtonFontColor: 'Font colour of the address button:',
    bgColor: 'Background colour:',
    bgOfRequiredActionInfo: 'Background colour of information about the required action:',
    buttonText: 'Button text:',
    city: 'The city:',
    companyNameFontSize: 'Size of company name:',
    companyNameColor: 'Color of the company name:',
    defaultSettings: 'Default settings',
    defaultSettingsRestored: 'Default settings are restored',
    defaultSettingsNotRestored: 'The default settings could not be restored.',
    emailHasBeenSent: 'E-mail was sent',
    emailNotSent: 'We were unable to send an e-mail',
    emailTitle: 'Email title:',
    showReservationDetailsAlt: 'Show order details:',
    textBeforeReservationDetailsAlt: 'Email content before order details:',
    textUnderReservationDetailsAlt: 'Email content under order details:',
    fontSizeForInfo: 'Information font size:',
    fontColorForInfo: 'Information font colour:',
    fontSizeForPrice: 'Price font size:',
    fontSize: 'Text size:',
    fontSizeXS: 'Very small text',
    fontSizeS: 'Small text',
    fontSizeM: 'Normal text',
    fontSizeL: 'Large text',
    fontSizeXL: 'Very large text',
    generalSettings: 'General settings',
    generalTitle: 'Sender name:',
    headerTitle: 'E-mail title text:',
    headerTitleNote: 'Leave empty to use the company name',
    hours2: '2 hours',
    hours3: '3 hours',
    hours4: '4 hours',
    hours5: '5 hours',
    hours6: '6 hours',
    hours7: '7 hours',
    hours8: '8 hours',
    hours9: '9 hours',
    hours10: '10 hours',
    hours11: '11 hours',
    hours12: '12 hours',
    hours24: '24 hours',
    hours48: '48 hours',
    hours72: '72 hours',
    image: 'Image:',
    leaveEmptyToHideButton: 'Leae empty to hide a button',
    mainFontSize: 'Main font size:',
    mainTextColor: 'Main font colour:',
    minutes15: '15 minutes',
    minutes30: '30 minutes',
    minutes45: '45 minutes',
    minutes60: '60 minutes',
    minutes75: '75 minutes',
    minutes90: '90 minutes',
    notSendReminder: 'Do not send a reminder',
    paymentButtonText: 'Button text:',
    priceFontColor: 'Price font colour:',
    restoreDefaultSettingsTitle: 'Resetting to default settings',
    restoreDefaultSettingsDesc: 'Are you sure you want to restore the default settings? All changes to general settings and email templates will be lost after saving the changes.',
    restoreDefaultSettingsBtn: 'Restore',
    restoreDefaultSettings: 'Restore the default settings',
    removeImage: 'Delete image',
    seePreview: 'See preview',
    seeSettings: 'See settings',
    selectLanguage: 'Choose your language:',
    selectTemplate: 'Select a template:',
    sendICS: 'Attach ICS files:',
    sendReminderBeforeReservation: 'Send <strong> a reminder</strong> before reservation',
    sendTestEmail: 'Send a test e-mail',
    sendingTestEmail: 'Sending a test message',
    settingsSaved: 'E-mail notification settings have been changed',
    showCancelButton: 'Show the cancellation button:',
    showReservationDetails: 'Show details of reservation:',
    showReservationParams: 'Show reservation parameters:',
    showPeopleNumber: 'Show people number:',
    showQuote: 'Show the amount to be paid:',
    showWorker: 'Show the employee',
    showTravelTips: 'Show how to get there:',
    templates: 'Message templates',
    templateSettings: 'Message template settings',
    templateAccepted: 'Reservation accepted',
    templateCancelled: 'Reservation cancelled',
    templateChangeTerm: 'Reservation date change',
    templateCartchanged: 'Change of cart status',
    templateChangePaymentStatus: 'Change of payment status by the company',
    templateMissingPayment: 'No payment',
    templateOrderNew: 'New order is waiting for payment',
    templateOrderPaid: 'Order paid',
    templatePaid: 'Reservation paid',
    templateAdvancePaid: 'Reservation partially paid',
    templateRejected: 'Reservation rejected',
    templateReminder: 'Reservation reminder',
    templateSurvey: 'Survey fill request',
    templateTerm: 'The date has been released',
    templateUnpaid: 'Awaiting payment',
    templateWaitingList: 'Assigning to the reservation list',
    testEmailAddress: 'Test e-mail address',
    textBeforeReservationDetails: 'Content of the e-mail before booking details:',
    textUnderReservationDetails: 'Content of the e-mail under booking details:',
    title: 'E-mail notification settings',
    toTestEmaiPleaseSaveChanges: 'To test your changes in the test email you send, remember to save your changes before sending it.',
    uploadFileToChangeImage: 'Send a new file to change the image',
    useNewTemplates: 'Use new templates:',
    warning: 'Attention!',
    week1: '1 week',
    week2: '2 weeks',
    week3: '3 weeks',
    weHaveAddedNewTemplates: 'We have added the possibility of including new, redesigned email templates. You can enable them in general settings.'
  },
  settingsGdpr: {
    additionalGdprText: 'Text will be automatically added to the content: "For details, see privacy policy." The privacy policy will be automatically linked.',
    agreementsTitle: 'Agreements configuration',
    dataRetentionTitle: 'Data retention settings',
    documentsTitle: 'Useful documents',
    downloadDocument: 'Download the document',
    emailAgreementText: 'Content of consent to the processing of data for marketing purposes using e-mails:',
    gdprDisclaimer: '<strong>NOTE!</strong> The above documents are templates that you can use in any way you like. You can change and modify the documents. SAFI STUDIO Paweł Nowakowski, 25 Spacerowa Street, 05-152 Czosnów, TAX ID: 531-161-08-55 as the owner of the Bookero system is not responsible for any misuse or misuse of the documents you post.',
    gdprInfoText: 'Content of the summary information obligation:',
    gdprUrl: 'URL of the information obligation clause:',
    getAgreementsForEmails: 'Collect permissions for marketing activities using e-mails:',
    getAgreementsForSupport: 'I allow access to personal data for the purpose of assistance by Support Bookero.',
    getAggrementsForSupportNote: 'Consent is granted only for the purpose of resolving reported issues.',
    getAgreementsForPhoneCalls: 'Collect permissions for marketing activities using phone calls:',
    ifItIsEnabledYouHaveToProvideAtLeastOneUrl: 'If this option is checked, fill in at least one of the above addresses: privacy policy and/or terms of service',
    ifInformationAgreeIsEnabledThisCannotBeEmpty: 'This field cannot be empty, if showing of the summary of the information obligation on the form is enabled',
    phoneCallsAgreementText: 'Content of consent to the processing of data for marketing purposes using telephone calls:',
    privacyPolicyUrl: 'Privacy policy URL:',
    removeDataNote: 'When canceling reservations, the first bookings from cycles and packages are skipped as long as there is still some connected future reservation.',
    removeDataAfterDaysReservations: 'After how many days from the reservation date should data be deleted?',
    removeDataAfterDaysCustomerAndReservations: 'After how many days of inactivity should the customer and their reservations be deleted?',
    removeDataAfterDaysCustomerAndReservationsNote: 'If the customer does not add a new reservation within a specified time, their data along with the reservations will be deleted. <strong>Reservations that do not have assigned customers WILL NOT BE removed.</strong>',
    removeDataAfterDaysCustomerAndReservationsNoteAlt: 'If the customer does not add a new reservation within a specified time, their data along with the reservations will be deleted. <strong class="is-invalid">Reservations that do not have assigned customers WILL BE removed.</strong>',
    removeDataByAgree: 'Do not delete customer and reservation data if the customer has given any marketing consent',
    removeDataWithoutCustomer: 'Remove reservations not assigned to any customer',
    removeDataWithoutCustomerDesc: 'If a booking has been assigned to a customer that no longer exists, it will be removed.',
    removeOldData: 'Automatically remove data from the system',
    removeOldDataOptions: {
      customersAndReservations: 'Remove customer and reservation data',
      notRemove: 'Do not remove',
      onlyReservations: 'Remove only reservation data'
    },
    settingsNotSaved: 'GDPR settings has not been saved. Please try again.',
    settingsSaved: 'GDPR settings have been changed',
    showCheckboxForTosOrPrivacyPolicy: 'Show the checkbox on the form with the acceptance of the ToS and/or privacy policy',
    showInFormShortGdprInfo: 'Show the summary of the information obligation on the form',
    supportAccessTitle: 'Consent to access the account for the support team',
    templateForDataProcessing: 'Upoważnienie do przetwarzania danych',
    templateForDPA: 'Model contract of entrustment of personal data processing',
    templateForGdprInfo: 'Model of full information obligation',
    templateForImageAgreement: 'Zgoda na wykorzystanie wizerunku',
    templateForRemoteWork: 'Zgoda na pracę zdalną',
    title: 'GDPR',
    tosUrl: 'URL to website with Terms of Service:',
    valueCannotBeEmpty: 'This value cannot be empty',
    valueInvalid: 'Invalid value - minimum period is 1 day'
  },
  settingsGoogleCalendar: {
    calendarTitle: 'Configure Google Calendar Integration',
    connectAccount: 'Connect your account to the Google Calendar',
    countOfRepeatingFutureReservations: 'Number of downloaded future recurring reservations',
    deleteConnection: 'Delete the link to this account',
    enableDuplexIntegration: 'Turn on the two-way integration',
    relatedAccount: 'Related account',
    removeConnection: 'Remove connecton',
    selectCalendar: 'Select a calendar',
    servicesTitle: 'Integrate services with your calendars',
    settingsSaved: 'Google Calendar settings have been changed',
    title: 'Google Calendar Settings',
    workerIsIntegratedWithHisAccount: 'The employee is integrated into his Google Account',
    workersTitle: 'Integrate employees into your calendars',
    youMustToCheckIntegrationBefore: '<strong>Note!</strong> It is worthwhile to first configure all calendars and check the one-way integration (i.e. from Bookero to Google) before we turn on the two-way integration'
  },
  settingsFakturownia: {
    apiToken: 'Token for API',
    autoEmail: 'Send the document automatically after creation',
    buyerCity: 'City of the buyer',
    buyerPostalCode: 'Postcode of the buyer',
    buyerStreet: 'Buyer\'s street',
    buyerTaxID: 'Buyer\'s Tax ID',
    companyName: 'Buyer\'s company name',
    companyID: 'Company ID',
    documentType: 'Document type',
    documentTypes: {
      invoice: 'Invoice',
      receipt: 'Receipt'
    },
    emptyServicesList: 'There are no services to enable invoices...',
    emptyPassesList: 'There are no passes to enable invoices...',
    enableInvoicesForSelectedPasses: 'Enable invoices for selected passes',
    enableInvoicesForSelectedServices: 'Enable invoices for selected services',
    endpointApiUrl: 'URL for the API endpoint',
    eReceipts: 'Use e-receipts',
    groupCarts: 'Group cart payments into one invoice',
    groupCartsDesc: 'For passes - purchases are always grouped, regardless of this setting',
    gtuCode: 'GTU code',
    hideTaxOnInvoice: 'Hide VAT on the invoice (empty value)',
    invoicesRequired: 'Invoice data required',
    integrateOnPayment: 'Integrate automatically upon receiving online payment',
    integrationTitle: 'Configure the integration with Fakturownia',
    integrationSettingsChanged: 'Fakturownia integration settings have been changed',
    issueReceiptWhenNoInvoice: 'Issue receipt when customer do not want an invoice',
    lack: 'None',
    mappingParamsTitle: 'Parameter mapping',
    personalInvoiceAsDefault: 'Check personal invoice by default while selecting invoice receiver',
    passTitle: 'Name on invoice',
    serviceTitle: 'Name of the service on invoice',
    title: 'Fakturownia Integration Settings',
    vatTax: 'VAT tax rate'
  },
  settingsGetResponse: {
    apiKey: 'GetResponse API key',
    integrationTitle: 'Configure GetResponse integration',
    integrationType: 'Integrate contacts when',
    integrationTypeTocAndPP: 'If terms and conditions and privacy policy are checked',
    integrationTypeNewsletter: 'If newsletter communication opt-in is checked',
    integrationTypeToCAndNewsletter: 'If terms and conditions and newsletter communication opt-in are checked',
    integrationSettingsChanged: 'GetResponse integration settings has been changed',
    listToken: 'GetResponse list token',
    selectValue: 'Select option',
    title: 'GetResponse integration settings',
    unsubscribeLabel: 'Remove from list if above conditions does not meet'
  },
  settingsMyPage: {
    addNewSection: 'Add a new section',
    allChangesSaved: 'All changes have been saved',
    editSettings: 'Edit settings',
    goForward: 'Go forward',
    loadingSiteData: 'Loading the page data...',
    noSections: 'No sections. Create the first section by clicking on the "Add new section" button at the top.',
    orderingSaved: 'The order of the sections has been saved',
    preview: 'Preview page',
    title: 'My site',
    unsavedChangesTitle: 'You have unsaved changes',
    unsavedChangesDesc: 'Unsaved changes in the configuration of your website were detected. By clicking the "Go ahead" button you will lose these modifications.'
  },
  settingsOutlookCalendar: {
    calendarTitle: 'Configure integration with Outlook calendar',
    connectAccount: 'Connect your account to the Outlook calendar',
    enableDuplexIntegration: 'Turn on the two-way integration',
    noSupportForMeetings: '<strong>Warning!</strong> This calendar does not allow creating online meetings',
    relatedAccount: 'Connected account',
    removeAccountConnection: 'Delete the connection to this account',
    removeConnection: 'Delete connection',
    selectCalendar: 'Select a calendar',
    servicesTitle: 'Integrate services with your calendars',
    settingsSaved: 'Outlook calendar settings have been changed',
    supportForMeetingsHowToCheckLinkLabel: 'To check whether meetings can be created for this integration',
    supportForMeetingsHowToCheckLink: 'go to the employee settings',
    title: 'Outlook calendar settings',
    workerIsIntegratedWithHisAccount: 'The employee is integrated into his Outlook account',
    workersTitle: 'Integrate employees into your calendars',
    youMustToCheckIntegrationBefore: '<strong>Note!</strong> It\'s worthwhile to first configure all calendars and check the one-way integration (i.e. from Bookero to Outlook) before you turn on the two-way integration'
  },
  settingsPaymentMethodsListItem: {
    changedDefaultPaymentMethod: 'Changed the default payment method',
    currency: 'Currency: ',
    defaultPaymentMethod: 'Default payment method',
    editPaymentMethod: 'Edit payment method',
    hiddenMethodCannotBeDefaultPaymentMethod: 'Hidden method cannot be the default',
    hide: 'Hide',
    hidePaymentMethod: 'Hide the payment method',
    name: 'Name: ',
    passes: 'Passes: ',
    publish: 'Publish',
    publishPaymentMethod: 'Publish the payment method',
    removePaymentMethod: 'Delete the payment method',
    removingPaymentMethodTitle: 'Removal of the payment method',
    removingPaymentMethodDesc: 'Are you sure you want to delete your chosen payment method?',
    removingPaymentMethodBtn: 'Delete the payment method',
    removedPaymentMethod: 'The selected payment method has been deleted',
    selectedPaymentMethodPublished: 'The chosen payment method has been published',
    selectedPaymentMethodUnpublished: 'The selected payment method has been unpublished',
    services: 'Services:',
    setAsDefaultPaymentMethod: 'Set as the default payment method',
    visibleOnlyForAdmin: 'This payment method is only visible to the administrator'
  },
  settingsPayments: {
    addMethod: 'Add the method',
    currency: 'Currency',
    default: 'Default',
    paymentMethod: 'Method of payment',
    paymentMethodDotpay: 'Payment via Dotpay',
    paymentHotPay: 'Payment via HotPay',
    paymentMethodIMoje: 'Payment via ING Pay',
    paymentMethodPayPal: 'Payment via PayPal',
    paymentMethodPayU: 'Payment via PayU',
    paymentMethodPrzelewy24: 'Payment through Transfers24',
    paymentMethodsTitle: 'Payment methods',
    paymentMethodTpay: 'Payment via Tpay',
    paymentMethodPayNow: 'Payment via PayNow',
    paymentMethodStripe: 'Payment via Stripe',
    paymentMethodsOrderingSaved: 'The order of payment methods has been saved',
    passes: 'Passes',
    services: 'Services',
    title: 'Payment settings'
  },
  settingsPlugin: {
    blockReservationsFromPlugin: 'Block the possibility of adding reservations via the plugin',
    byEnablingThisOptionYouWillSplitServiceChoiceToTwoSteps: 'Enabling this option will divide the service selection into two steps',
    configureBlockingTitle: 'Configure the blocking of reservations by plugin',
    configureTrackingTitle: 'Configure integrations with analytics services',
    configurationTitle: 'Configure the plugin visible on the page',
    disableDefaultWorker: 'Hide the option to select any employee',
    enableCart: 'Enable reservations cart',
    functionAvailableOnlyInMonthlyBoxMode: 'This function is only available in the Monthly Box plugin.',
    ga4streamID: 'GA4 Stream ID',
    hideHourChoice: 'Hide the time selection:',
    hidePassesStartDate: 'Hide the start date selection when buying pass:',
    hidePassesStartDateDesc: 'Available only in plugin with option to buy passes.',
    itIsSpecificWayToSendDataToGA: 'This solution may impact data collection in GTM. It serves as an alternative to configuring events in GTM and allows sending events directly to GA4.',
    leftDateAndTime: 'Leave the date and time',
    messageAfterReservationAccept: 'Content of the plugin message that will appear after <strong>acceptance</strong> reservation:',
    messageAfterReservationReject: 'Content of the plugin message that will appear after <strong>rejection</strong> reservation:',
    messageForReservationWaitingForAccept: 'Content of the plugin message that will appear in case of <strong>waiting payment</strong> reservation:',
    messageAfterSucessfulSendingForm: 'Content of the plugin message that will appear when the booking form is sent correctly:',
    messageDanger: 'A very important message',
    messageInfo: 'Information',
    messageOrderAccept: 'Content of the plugin message that will appear after <strong>acceptance</strong> of products order:',
    messageOrderReject: 'Content of the plugin message that will appear after <strong>rejection</strong> of products order',
    messageOrderPayment: 'Content of the plugin message that will appear in case of <strong>waiting payment</strong> products order:',
    messageStyle: 'Message style:',
    messageWarning: 'Warning',
    messageWaitingList: 'ontent of the plugin message that will appear after <strong>assigning to the waiting list</strong>',
    messageWillAppearInsteadOfForm: 'Content of the plugin message that will appear instead of the form:',
    messageWillAppearOverForm: 'Content of the plugin message that appears above the form:',
    msgConfirmed: 'Thank you for choosing a date.',
    msgDenied: 'Rejection of reservation. There are free places at this time.',
    msgSent: 'Thank you for sending us your inquiry. Do not close the form and wait for a reply or check your e-mail.',
    msgWaitingList: 'Your reservation has been assigned to the waiting list.',
    msgOrderConfirmed: 'We confirm that your order has been placed.',
    msgOrderDenied: 'Order rejected. Purchase is not possible.',
    msgOrderPayment: 'Please proceed with the payment to confirm your purchase. You can make the payment by clicking the button below.',
    no: 'No',
    notSendingDataToGTM: 'I am not using GTM on the site',
    pluginEventsDebugMode: 'Enable plugin events debug mode',
    rememberToConfigureGTM: 'For event handling to work, you must configure custom event handling in GTM',
    resetDateAndTime: 'Reset everything',
    resetOnlyTime: 'Reset only hour',
    resetTermAfterAddToCart: 'Resetting the selected date after adding it to the reservations cart',
    selectFirstService: 'Select first service by default',
    sendingDataDirectlyToGA: 'I use GTM, but send data directly to GA4',
    sendingDataToGTM: 'Send data to GTM',
    settingsSaved: 'The plugin settings have been changed',
    showAllHours: 'All',
    showAvailableHours: 'Display the available hours',
    showOnlyFirstAvailableHour: 'Only the first available:',
    showPriceBeforeAddToCart: 'Show price before going to summary',
    showPriceBeforeAddToCartDesc: 'After enabling this option, price will be displayed and updated according to user\'s choices during first step of making a reservation',
    showPrices: 'Show prices:',
    showPricesInSummary: 'Show in summary',
    showPricesOnServicesList: 'Show on the list of services',
    showPricesOnServicesListAndSummary: 'Show in the list of services and in the summary',
    showWorkersDetails: 'Show the employee descriptions',
    title: 'Plugin settings',
    twoStepServiceChoice: 'Two-step service selection',
    useFB: 'Track data with Facebook Pixel',
    useGA: 'Track data with Google Analytics 4',
    usingGTM: 'Should the plugin send data to Google Tag Manager (GTM)?',
    useStyledDropdowns: 'Use styled selection lists',
    warning: 'Attention!'
  },
  settingsReservations: {
    additionalReservationsFeaturesTitle: 'Additional functions related to reservations',
    additionalReservationsRulesTitle: 'Additional reservations rules',
    allowFutureReservationsAtMax: 'Allow maximum reservations:',
    allowPeriodicityCancel: 'Allow to cancel the whole reservation cycle:',
    allowPeriodicityCancelDesc: 'When this option is enabled, the customer cancelling a recurring reservation will also be able to cancel all future reservations from the cycle.',
    allowReservationCancellationAtMax: 'Allow reservation cancellation maximum:',
    allowWorkerSelect: 'Allow employee to choose:',
    autoAttendances: 'Automatically mark attendances:',
    autoWaitingList: 'Automatically send notifications about free term:',
    commissions: 'Enable commissions',
    configureReservationsTitle: 'Configure how customers add their reservations',
    customersBasedOn: 'Create new customers based on:',
    days5: '5 days',
    days7: '7 days',
    days10: '10 days',
    days14: '14 days',
    daysForward: 'days forward',
    doNotAllowMoreThanOneReservationForTheSameTermAddedByOneUser: 'User cannot create more than one reservation per hour',
    doNotManageCustomers: 'don\'t manage customers',
    emailAddress: 'e-mail address',
    enableDiscountCodes: 'Enable discount codes:',
    enableAttendancesList: 'Enable attendances list:',
    enableWaitingList: 'Enable a waiting list:',
    hidePhoneField: 'Hide the field for entering the phone number:',
    hoursBefore: 'hours before',
    hours1: '1 hour 0 min.',
    hours1minutes5: '1 hour 5 min.',
    hours1minutes10: '1 hour 10 min.',
    hours1minutes15: '1 hour 15 min.',
    hours1minutes20: '1 hour 20 min.',
    hours1minutes25: '1 hour 25 min.',
    hours1minutes30: '1 hour 30 min.',
    hours1minutes35: '1 hour 35 min.',
    hours1minutes40: '1 hour 40 min.',
    hours1minutes45: '1 hour 45 min.',
    hours1minutes50: '1 hour 50 min.',
    hours1minutes55: '1 hour 55 min.',
    hours2: '2 hours 0 min.',
    hours2minutes30: '2 hour 30 min.',
    hours3: '3 hours',
    hours3minutes30: '3 hrs 30 min.',
    hours4: '4 hrs.',
    hours4minutes30: '4 hrs 30 min.',
    hours5: '5 hrs.',
    hours5minutes30: '5 hrs 30 min.',
    hours6: '6 hrs.',
    hours12: '12 hrs.',
    hours24: '24 hours.',
    hours48: '48 hours.',
    hours72: '72 hours.',
    minutes15: '15 min.',
    minutes20: '20 min.',
    minutes25: '25 min.',
    minutes30: '30 min.',
    minutes35: '35 min.',
    minutes40: '40 min.',
    minutes45: '45 min.',
    minutes50: '50 min.',
    minutes55: '55 min.',
    nextDay: 'The next day',
    passes: 'Enable passes',
    passesDisabledDesc: 'Disabling creation of customers based on e-mail or phone means passes cannot be active and have been disabled.',
    passesDisabledTitle: 'Passes disabled',
    periodicity: 'Reservation periodicity and reservation packages',
    phoneNumber: 'phone number',
    phonePrefix: 'Default country for the phone number',
    phonePrefixDesc: 'Country code eg. "gb", "de", "it"',
    reservationsDistance: 'Reservations in advance:',
    reservationSettingsSaved: 'The reservation settings have been changed',
    requireEmail: 'Require the entry of an e-mail address',
    requirePeopleNumber: 'Specify number of people for each reservation',
    requirePhone: 'Requires entry of a telephone number',
    services: 'Services',
    servicesLabel: 'Label for service list:',
    syncAvailableHoursAccordingToAvailability: 'Start the available hours in relation to availability:',
    syncHoursDescription: 'Select the schedule you want to show the schedule for. If you select "Employee", the first available hour will be the start time of the selected employee. If you select "Service", the schedule will start from the first available hour for the selected service.',
    textDisplayedWhenCannotCancel: 'Text used when cancellation time is expired:',
    thisOptionRequiresCustomersManagementEnabled: 'This option is available, when customer creation based on e-mail/phone is enabled',
    thisOptionRequiresPaymentsEnabled: 'This option is available when payments are enabled.',
    thisOptionRequiresWorkersEnabled: 'This option is available when workers are enabled.',
    thisOptionRequiresServicesAndPaymentsEnabled: 'This option is available when services and payments are enabled.',
    timeSpaces: 'Intervals when selecting the time of reservations',
    timeSpacesTheSameAsServiceDuration: 'Intervals such as the duration of the service',
    title: 'Reservation settings',
    workers: 'Employees',
    youCannotDisableThisOptionIfCustomersAreBasedOnEmail: 'This option cannot be disabled if you choose to create new clients based on the e-mail address',
    youCannotDisableThisOptionIfCustomersAreBasedOnPhone: 'This option cannot be deactivated if you select to create new customers based on the phone number.',
    zeroMeansNoLimits: '0 means no restrictions'
  },
  settingsSms: {
    betweenNightHours: 'Between 22:00 and 6:00',
    cancelReservationBySms: 'Cancellation by SMS:',
    cancellationIsTriggeredBySmsResponse: 'Cancellation of the reservation is done by answering a text message reminding',
    okUnderstand: 'OK, I understand',
    sendReminderBeforeReservation: 'Send a reminder before reservation:',
    smsAbroadNotice: 'If the option is enabled, the cost of SMS will be 0.21 GBP net',
    smsCancellationTemplate: 'Cancelled! {data} {godzina} {usługa}',
    smsCancelNotice: 'The cost of an SMS to a foreign number is 0.21 GBP net',
    smsCantCancelTemplate: 'Cannot cancel reservation: {data} {godzina} {usluga}',
    smsContent: 'Content of the SMS reminder:',
    smsContentForCancelledReservation: 'The content of SMS that the customer will receive when cancelling a reservation via SMS:',
    smsContentForCantCancelReservation: 'The content of SMS that the customer will receive when reservation cannot be cancelled via SMS:',
    smsContentTitle: 'Content of SMS messages',
    smsNotificationTemplate: 'Reminder! {data} {godzina} {usługa}',
    smsSendingSettings: 'SMS sending settings',
    smsSent: 'SMS was sent',
    smsSettingsChanged: 'SMS settings have been changed',
    smsTextToCancel: 'SMS text to cancel reservation',
    smsTextToCancelDesc: 'Leave this field empty to allow any SMS text to cancel reservation',
    submitSmsAbroad: 'Send SMS to foreign numbers',
    submitSmsAtNight: 'Send reminders also at night:',
    submitTestSmsTo: 'Send a test SMS to:',
    submitTestSms: 'Send a test SMS',
    title: 'SMS notification settings',
    unableToSendSms: 'Failed to send SMS',
    warning: 'Attention!',
    warningSmsContentText: 'Click here and get to know how content of your SMS notifications can affect number of SMS messages used per notification.'
  },
  settingsWww: {
    analyticsIntegrationsTitle: 'Integration with analytical services',
    configureTitle: 'Configure your website',
    facebook: 'Facebook:',
    facebookPixelID: 'Meta Pixel ID:',
    facebookPixelIDdesc: 'Formerly Facebook Pixel. <a href="https://en-gb.facebook.com/business/help/171689010314963" target="_blank" rel="noopener noreferrer nofollow">Check how to find Meta Pixel ID</a>',
    google: 'Google profile:',
    googleAnalyticsID: 'Google Analytics 4 tag ID:',
    googleAnalyticsIDdesc: 'Check <a href="https://support.google.com/analytics/answer/9539598?hl=en" target="_blank" rel="noopener noreferrer nofollow">how to find tag ID</a> in Google Analytics 4.',
    instagram: 'Instagram:',
    linkedin: 'LinkedIn:',
    menuHide: 'Hide menu',
    menuLogoCenter: 'Menu with logo at center',
    menuLogoLeft: 'Menu with logo at left',
    ogImage: 'Open Graph image',
    pinterest: 'Pinterest:',
    pleaseProvideUrl: 'Please provide a page URL',
    primaryColor: 'Primary color:',
    rememberAboutPluginTracking: 'Remember to properly configure data tracking in the plugin.',
    secondaryColor: 'Secondary color:',
    showMenu: 'Show the menu:',
    showPhone: 'Show the phone number:',
    showSocialMediaIcons: 'Show social media icons:',
    socialMediaLinks: 'Links to social networking sites',
    submitNewFileToChangeFavicon: 'Send a new file to change the favicon',
    submitNewFileToChangeOgImage: 'Send a new file to change the Open Graph image. Preferred dimensions: 1200x630px',
    title: 'Website settings',
    tripAdvisor: 'TripAdvisor:',
    twitter: 'X (formerly Twitter):',
    urlIsUnavailable: 'The given domain name is already taken. Please select another address.',
    websiteDescription: 'Page summary:',
    websiteFavicon: 'Favicon:',
    websiteKeywords: 'Keywords:',
    websiteName: 'Name of page:',
    websiteSettingsSaved: 'Web page settings have been changed',
    websiteUrl: 'Page address:',
    youtube: 'YouTube:'
  },
  sidebar: {
    attendances: 'Attendances',
    billing: 'Settlements',
    blockedTermins: 'Blocked termins',
    calendar: 'Calendar',
    clients: 'Customers',
    company: 'Company data',
    config: 'Configuration',
    day: ' day',
    days: ' days',
    discounts: 'Discount codes',
    history: 'Reservation history',
    home: 'My panel',
    integrations: 'Integrations',
    invoices: 'Sales documents',
    myPage: 'Your website',
    openingRules: 'Opening rules',
    passes: 'Passes',
    passesActive: 'Active passes',
    payments: 'Payment history',
    priceRules: 'Price rules',
    rules: 'Rules',
    reservationParams: 'Reservation parameters',
    reservationRules: 'Reservation rules',
    services: 'Services',
    settings: 'Settings',
    smsHistory: 'SMS history',
    stats: 'Statistics',
    surveys: 'Surveys',
    surveysFilled: 'Filled surveys',
    waitingList: 'Waiting list',
    workers: 'Employees',
    yourCompany: 'Your company',
    yourPackageExpiresIn: 'Your package expires for ',
    yourProfile: 'Your profile',
    yourReservations: 'Your reservations'
  },
  smsHistory: {
    details: 'Details',
    message: 'Message',
    noMessages: 'No text messages were found...',
    noMessagesForGivenFilters: 'No SMS messages matching your criteria were found...',
    receiver: 'Recipient',
    reservation: 'Reservation',
    sendTime: 'Time of send',
    smsCount: 'Number of SMS',
    smsType: 'Type of SMS',
    title: 'SMS history'
  },
  smsHistoryListItem: {
    count: 'Number of messages:',
    message: 'Message content:',
    receiver: 'Recipient:',
    reservation: 'Reservation #{inquiryID}',
    sent: 'Sent:',
    sms: 'SMS',
    type: 'Type of message:',
    typeCancel: 'Message after cancellation',
    typeNotification: 'Notification'
  },
  splashscreen: {
    loadingText: 'Loading data...'
  },
  statistics: {
    accepted: 'Accepted',
    cancelled: 'Cancelled',
    commission: 'Commission',
    discounts: 'Used discounts',
    dateRanges: {
      last7days: 'Last 7 days',
      last30days: 'Last 30 days',
      last90days: 'Last 90 days',
      last180days: 'Last 180 days',
      last365days: 'Last 365 days',
      thisWeek: 'This week',
      thisMonth: 'This month',
      thisQuarter: 'This quarter',
      thisYear: 'This year',
      previousWeek: 'Previous week',
      previousMonth: 'Previous month',
      previousQuarter: 'Previous quarter',
      previousYear: 'Previous year',
      custom: 'Custom period'
    },
    dateTypeCreated: 'Display by booking creation date',
    dateTypeReservationDate: 'Display by reservation date',
    income: 'Income',
    passCodes: 'Used passes',
    rejected: 'Rejected',
    showLess: 'Show less',
    showMore: 'Show more',
    title: 'Statistics',
    titles: {
      common: 'General',
      passes: 'Passes',
      passesByIncome: 'By income',
      selectedService: 'For selected service',
      selectedWorker: 'For selected worker',
      services: 'Services',
      servicesByCommission: 'By commission',
      servicesByIncome: 'By income',
      servicesByAccepted: 'By number of accepted reservations',
      workers: 'Workers',
      workersByCommission: 'By commission',
      workersByIncome: 'By income',
      workersByAccepted: 'By number of accepted reservations'
    },
    total: 'All'
  },
  stats: {
    accepted: 'Accepted',
    allTotal: 'All together',
    cancelled: 'Cancelled',
    change: 'Change',
    hideStats: 'Hide the statistics',
    hideValues: 'Hide values',
    newClients: 'New customers',
    percentTotal: 'Percentage of total',
    reservations: 'Reservations',
    showStats: 'Show statistics',
    showValues: 'Show values',
    trade: 'Turnover'
  },
  statsChart: {
    accepted: 'Accepted',
    all: 'All',
    cancelled: 'Cancelled',
    commission: 'Commission',
    confirmed: 'Confirmed',
    income: 'Income',
    incomeAndCommissions: 'Income and commissions',
    passesIncome: 'Passes income',
    rejected: 'Rejected',
    reservations: 'Reservations',
    title: 'Reservations chart'
  },
  surveys: {
    addNew: 'New survey',
    name: 'Name',
    noSurveys: 'No surveys...',
    noSurveysForGivenFilters: 'No surveys for given criteria...',
    services: 'Services',
    systemName: 'Survey description',
    thisSurveyIsNotPublished: 'This survey is not published',
    title: 'Surveys'
  },
  surveysFilled: {
    allSurveys: 'All surveys',
    date: 'Date',
    export: 'Export',
    filePrefix: 'Survey',
    inquiry: 'Related reservation',
    scoring: 'Score',
    surveyName: 'Survey name',
    title: 'Filled surveys'
  },
  surveyFilledListItem: {
    reservation: 'See reservation',
    seeSurvey: 'See answers'
  },
  surveyForm: {
    addAnswer: 'Add answer',
    addTitle: 'Add survey',
    addQuestion: 'Add question',
    answerScoring: 'Score',
    answerText: 'Answer text',
    attendance: 'Customer attendance',
    availableAnswers: 'Available answers',
    closedQuestion: 'Closed question',
    configurationTitle: 'Survey configuration',
    editTitle: 'Edit survey',
    emptyStateForAnswers: 'No answers',
    emptyStateForQuestions: 'No questions',
    hiddenSurveysAreVisibleOnlyInAdminPanel: 'Hidden surveys are visible only in the administration panel',
    hideSurvey: 'Hide survey',
    hoursToSend: 'How many hours before/after reservation send the survey?',
    name: 'Name',
    openQuestion: 'Closed question?',
    removeAnswer: 'Remove answer',
    removeQuestion: 'Remove question',
    requiredQuestion: 'Answer required',
    surveyAdded: 'Survey has been added',
    surveyChanged: 'Survey has been changed',
    question: 'Question',
    questionIsRequired: 'Answer required?',
    questionsTitle: 'Survey content',
    sendOnce: 'How to send survey?',
    sendOnceOptionOnce: 'Only once - not repeat for next reservations',
    sendOnceOptionEverytime: 'With every reservation',
    sendType: 'When send the survey?',
    sendTypeOptionAfter: 'After reservation',
    sendTypeOptionBefore: 'Before reservation',
    sendTypeOptionAfterSave: 'After add reservation to the system',
    servicesTitle: 'Limit survey to selected services',
    servicesDesc: 'If no services are selected - the survey will work for the all services',
    skipAttendance: 'Do not handle attendance',
    systemName: 'Survey description',
    textThankYou: 'Text which will be displayed after filling a survey',
    textToEmail: 'Text attached to the e-mail with survey fill request',
    textToSurvey: 'Intro text displayed on the survey page',
    whenUserNotPresent: 'Customer not present',
    whenUserPresent: 'Customer present'
  },
  surveysListItem: {
    editSurvey: 'Edit survey',
    hideSurvey: 'Hide survey',
    publishSurvey: 'Publish survey',
    previewSurvey: 'Open preview',
    removeSurvey: 'Remove survey',
    removingSurveyTitle: 'Removing survey',
    removingSurveyDesc: 'Do you really want to remove the selected survey?',
    removingSurveyBtn: 'Remove survey',
    selectedSurveyHasBeenRemoved: 'Selected survey has been removed',
    selectedSurveyPublished: 'Selected survey has been published',
    selectedSurveyUnpublished: 'Selected survey has been hidden'
  },
  surveyPreviewPopup: {
    loadError: 'An error occurred during loading the preview',
    openLink: 'Open preview in a new tab',
    title: 'Survey preview'
  },
  surveyResultsPopup: {
    score: 'Score',
    title: 'Answers in survey'
  },
  topBar: {
    attendances: 'Attendances',
    billing: 'Settlements',
    blockedTermins: 'Blocked termins',
    calendar: 'Calendar',
    checkNews: 'New features!',
    clients: 'Customers',
    checkTerm: 'Find free date',
    cookieSettings: 'Cookie settings',
    companyData: 'Company data',
    disableReservations: 'Disable reservations',
    disableReservationsDesc: 'Are you sure you want to disable the possibility of adding reservations on the site?',
    disableReservationsTitle: 'Disabling reservations',
    discounts: 'Discount codes',
    documentation: 'Documentation',
    enableReservations: 'Enable reservations',
    help: 'Help',
    history: 'Reservation history',
    integrations: 'Integrations',
    invoices: 'Sales documents',
    logout: 'Logout',
    myPage: 'Your website',
    new: 'News',
    noInternetConnection: 'No internet connection.',
    openingRules: 'Opening rules',
    passes: 'Passes',
    passesActive: 'Active passes',
    payments: 'Payment history',
    priceRules: 'Price rules',
    refreshApp: 'Refresh',
    reservationsDisabled: 'The possibility of adding reservations on the website has been disabled',
    reservationsEnabled: 'The possibility of adding reservations on the website has been enabled',
    reservationParams: 'Reservation parameters',
    reservationRules: 'Reservation rules',
    services: 'Services',
    settings: 'Settings',
    smsHistory: 'SMS history',
    stats: 'Statistics',
    surveys: 'Surveys',
    surveysFilled: 'Filled surveys',
    updateAvailable: 'Updated Bookero version is available - refresh website to get access',
    waitingList: 'Waiting list',
    workers: 'Employees',
    yourPanel: 'Your panel',
    yourProfile: 'Your profile'
  },
  topBarSearch: {
    placeholder: 'Look for reservations...'
  },
  waitingList: {
    actions: 'Actions',
    additionalInformations: 'Additional information',
    client: 'Reserved by',
    date: 'Date',
    exportAs: 'Export as ',
    filePrefix: 'waiting-list.',
    noReservations: 'No reservations were found...',
    noReservationsForGivenFilters: 'No reservations were found for the given criteria...',
    service: 'Service',
    status: 'Reservation status',
    title: 'Waiting list'
  },
  waitingListItem: {
    call: 'Call',
    cardRegistered: 'Card registered',
    category: 'Category: ',
    formSent: 'Form sent:',
    notificationDate: 'Notification about free term:',
    notificationNotSend: 'System was unable to send a notification',
    notificationSend: 'Notification about free term has been sent',
    paid: 'Paid',
    reservationDetails: 'Reservation details #{id}',
    reservationParentDetails: 'Parent reservation #{id}',
    seeMore: 'See more',
    sendEmail: 'Send e-mail',
    sendNotification: 'Notify',
    unPaid: 'Unpaid'
  },
  workers: {
    addWorker: 'Add an employee',
    email: 'E-mail',
    emailNotifications: 'E-mail notifications',
    googleCalendarIntegration: 'Integration with Google Calendar',
    maxWorkersUsed: 'You currently use the maximum number of employees in your plan ({maxWorkers} employees).',
    name: 'First and last name',
    noWorkers: 'No employees were found...',
    noWorkersForTheGivenCriteria: 'No employees meeting the criteria...',
    outlookCalendarIntegration: 'Integration with Outlook Calendar',
    searchForWorkers: 'Search for employees...',
    services: 'Services',
    title: 'Employees'
  },
  workerForm: {
    appLanguage: 'App language',
    avatar: 'Avatar:',
    avatarColor: 'Avatar colour:',
    calendar: 'Calendar:',
    confirmPassword: 'Confirm password:',
    connectedGoogleAccount: 'Connected Google Account',
    connectedOutlookAccount: 'Connected Outlook account',
    fillThisFieldToChangePassword: 'Fill in this field if you want to change your password',
    initials: 'Initials:',
    initialsDescription: 'Maximum 2 characters. This field will be completed automatically if you leave it blank.',
    name: 'First and last name:',
    password: 'Password:',
    providedPasswordsAreNotTheSame: 'The passwords given are not identical',
    removeAvatar: 'Remove the avatar',
    removeConnectedAccount: 'Delete the connection to this account',
    selectCalendar: 'Select a calendar',
    settingsTitle: 'Settings',
    submitNewFileToChangeAvatar: 'Send a new file to change your avatar',
    yourData: 'Your data',
    yourDataHasBeenChanged: 'Your data has been changed',
    yourProfile: 'Your profile',
    workHoursTitle: 'Work hours'
  },
  workersForm: {
    addTitle: 'Adding an employee',
    appLanguage: 'App language',
    avatar: 'Avatar:',
    avatarColor: 'Avatar colour:',
    calendar: 'Calendar:',
    canChangePaymentStatus: 'Can change payment status:',
    canManageBlockedTermins: 'Can manage blocked dates:',
    canManageBlockedTerminsCannot: 'can not manage',
    canManageBlockedTerminsOnlyOwn: 'can manage only own',
    canManageBlockedTerminsAll: 'can manage all',
    canManageExceptions: 'Can manage company opening hours rules:',
    canManageOwnReservations: 'Can manage his bookings:',
    canManageOwnWorkHours: 'Can manage his schedule:',
    canManageReservations: 'Can manage reservations:',
    canManageWorkerExceptions: 'Can manage worker rules:',
    canManageWorkerExceptionsCannot: 'can not manage',
    canManageWorkerExceptionsOnlyOwn: 'can manage only own',
    canManageWorkerExceptionsAll: 'can manage all',
    canSeePasses: 'Can see passes',
    canSeePassesOnlyForReservations: 'Can see passes only for single reservations',
    canSeePayments: 'Can see payments',
    canSeePaymentsOnlyForReservations: 'Can see payments only for single reservations',
    canSeeSurveys: 'Can see surveys',
    canSeeSurveysOnlyForReservations: 'Can see surveys only for single reservations',
    commissions: {
      commissionValue: 'Commission value',
      noCommission: 'No commission',
      percentageCommission: 'Percentage commission',
      quoteCommission: 'Quote commission'
    },
    confirmPassword: 'Confirm password:',
    connectedAccount: 'Connected account:',
    description: 'Description:',
    disableWorker: 'Disable the employee:',
    disableWorkerDescription: 'The disabled employee will be visible only in the administration panel.<br>The employee will not be taken into account when searching for available dates.',
    editTitle: 'Editing an employee',
    email: 'E-mail:',
    emailNotification: 'E-mail notifications:',
    fillThisFieldToChangePassword: 'Fill in this field if you want to change your password',
    googleCalendarIntegration: 'Integration with Google Calendar:',
    limitOfReservationsPerTerm: 'Reservation limit per date:',
    initials: 'Initials:',
    initialsDescription: 'Maximum 2 characters. This field will be completed automatically if you leave it blank.',
    integrationWithOutlookCalendar: 'Integration with Outlook Calendar:',
    name: 'First and last name:',
    openingHoursTitle: 'Work hours rules',
    password: 'Password:',
    permissionsTitle: 'Permissions',
    providedPasswordsAreNotTheSame: 'The passwords given are not identical',
    reception: 'Reception',
    removeAvatar: 'Remove the avatar',
    removeConnectedAccount: 'Delete the link to this account',
    selectCalendar: 'Select a calendar',
    servicesTitle: 'Services',
    settingsTitle: 'Settings',
    submitNewFileToChangeAvatar: 'Send a new file to change your avatar',
    userData: 'User data',
    userType: 'Type of user:',
    worker: 'Company employee',
    workerAdded: 'An employee has been added',
    workerDataChanged: 'The employee data has been changed',
    workHoursTitle: 'Working hours',
    youMustProvidePasswordForWorker: 'You must provide a password for the employee'
  },
  workersListItem: {
    accountType: 'Account type:',
    disableWorker: 'Disable the employee',
    editWorker: 'Edit the employee',
    email: 'E-mail:',
    emailNotConfirmed: 'E-mail requires confirmation',
    emailNotification: 'E-mail notifications:',
    enableWorker: 'Enable the employee',
    googleCalendarIntegration: 'Integration with Google Calendar',
    hide: 'Hide',
    hideWorker: 'Hide the employee',
    no: 'No',
    noOutlookCalendarForThisWorker: 'No Outlook calendar assigned to this employee.',
    noServicesForThisWorker: 'No services assigned to this employee.',
    notApplies: 'not applicable',
    outlookCalendarIntegration: 'Integration with Outlook Calendar',
    publish: 'Publish',
    publishWorker: 'Publish the employee',
    reception: 'Reception',
    removeWorker: 'Remove the employee',
    removingWorkerTitle: 'Removal of an employee',
    removingWorkerDesc: 'Are you sure you want to remove the selected employee?',
    removingWorkerBtn: 'Remove the employee',
    selectedWorkerHasBeenDisabled: 'The selected employee has been disabled',
    selectedWorkerHasBeenEnabled: 'The selected employee has been enabled',
    selectedWorkerHasBeenRemoved: 'The selected employee has been removed',
    services: 'Services:',
    thisWorkerIsDisabled: 'This employee is disabled',
    worker: 'employee',
    yes: 'Yes'
  }
};



// WEBPACK FOOTER //
// ./src/langs/en.js